<template>
  <PostLoginHeader />
  <main style="height: 90vh">
    <transition name="fade" style="z-index: 2000" v-if="showManageScenariosModal">
      <ManageScenariosModal
        @close="showManageScenariosModal = false"
        @mount="mount"
        :selectedCase="selectedCase"
        :mainCase="mainCase"
        :charges="charges"
      >
      </ManageScenariosModal>
    </transition>
    <transition name="fade" v-if="showInstructionModal" style="z-index: 2000">
      <Modal>
        <template v-slot:header>
          <span class="d-flex flex-row justify-content-between col-12">
            <div></div>
            <h2 class="fw-bold">{{ instructionObject.header }}</h2>
            <button class="btn btn-gray btn-xl float-right" @click="showInstructionModal = false">
              <i class="fa fa-close"></i>
            </button>
          </span>
        </template>

        <template v-slot:body>
          <div class="d-flex flex-column fs-5">
            <p v-for="line in instructionObject.body.split('\n')">{{ line }}</p>
          </div>
        </template>
      </Modal>
    </transition>
    <transition name="fade" v-if="showTextModal" style="z-index: 2000">
      <Modal :customClass="modalObject.table ? '' : 'modal-readable'">
        <template v-slot:header>
          <span class="d-flex flex-row justify-content-between align-items-center col-12">
            <div></div>
            <h2 class="fw-bold fs-3">{{ modalObject.header }}</h2>
            <button class="btn btn-gray btn-xl float-right" @click="showTextModal = false">
              <i class="fa fa-close"></i>
            </button>
          </span>
        </template>

        <template v-slot:body>
          <div class="fs-5 pl-2" v-html="modalObject.body"></div>
          <div v-if="modalObject.table">
            <DotsonTable v-if="modalObject.table.component == 'DotsonTable'" :chg="modalObject.table.argument">
            </DotsonTable>
            <CreditsTable
              v-else-if="modalObject.table.component == 'CreditsTable'"
              :charges="charges.data"
              :totalExpectedSentence="totalExpectedSentence"
            ></CreditsTable>
          </div>
        </template>
        <template v-slot:footer>
          <!-- <div class="d-flex justify-content-evenly">
          <button class="btn btn-primary" @click="showTextModal = false">Close</button>
        </div> -->
        </template>
      </Modal>
    </transition>

    <!-- Modal for hide report legend information, not a actionable modal, but just informational aboout what this filter does -->
    <Modal v-show="hideReportLegendInfoModal" size="small" style="z-index: 2000">
      <template v-slot:header>
        <div class="d-flex justify-content-between align-items-center w-100">
          <div></div>
          <h1 class="fs-3 fw-bold">Hide Report Legend</h1>
          <button class="btn btn-gray btn-xl" @click="hideReportLegendInfoModal = false">
            <i class="fa fa-close"></i>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <div class="d-flex justify-content-center align-items-center">
          <div class="d-flex justify-content-center align-items-center">
            <div class="d-flex justify-content-center align-items-center">
              <div class="d-flex justify-content-center align-items-center">
                This filter hides the legend for the Collateral Consequences report.
              </div>
            </div>
          </div>
        </div>
      </template>
    </Modal>

    <Modal v-show="clientModeInfoModal" size="small" style="z-index: 2000">
      <template v-slot:header>
        <div class="d-flex justify-content-between align-items-center w-100">
          <div></div>
          <h1 class="fs-3 fw-bold">Client Mode</h1>
          <button class="btn btn-gray btn-xl" @click="clientModeInfoModal = false">
            <i class="fa fa-close"></i>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <div class="d-flex justify-content-center align-items-center">
          <div class="d-flex justify-content-center align-items-center">
            <div class="d-flex justify-content-center align-items-center">
              <div class="d-flex justify-content-center align-items-center">
                This setting shortens statuses such as Convicted, Acquitted, Dismissed, Stayed 654, and Stayed on
                Incarceration Summary, and the Probation report to show a client.
              </div>
            </div>
          </div>
        </div>
      </template>
    </Modal>

    <Modal v-show="showDeleteChargePopup" style="z-index: 2000">
      <template v-slot:header>
        <div class="d-flex justify-content-between align-items-center w-100">
          <div></div>
          <h1 class="fs-3 fw-bold">Delete Charge</h1>
          <button class="btn btn-gray btn-xl" @click="showDeleteChargePopup = false">
            <i class="fa fa-close"></i>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <div class="d-flex flex-column fs-5">
          <p class="mb-3">Are you sure you wish to delete the following:</p>
          <ul class="m-0 p-0 mb-5" v-if="charges.data?.length > 0 && selectedCharge !== null">
            <li class="m-0 p-0 list-style-none">
              Count {{ charges?.data[selectedCharge]?.CountNumber }}:
              {{ charges?.data[selectedCharge]?.SectionNumber }}
              {{ charges?.data[selectedCharge]?.Name }}
            </li>
            <li
              class="m-0 p-0 list-style-none"
              v-for="enh in charges.data.filter(
                (chg) =>
                  selectedCharge !== null &&
                  chg.CountNumber == charges.data[selectedCharge]?.CountNumber &&
                  chg.CrimeTypeId !== 5 &&
                  charges.data[selectedCharge]?.CrimeTypeId == 5
              )"
            >
              Count {{ enh?.CountNumber }}: {{ enh?.SectionNumber }}
              {{ enh?.Name }}
            </li>
          </ul>
          <div class="d-flex justify-content-evenly w-100">
            <div>
              <button
                class="btn btn-primary btn-xl"
                ref="deleteButton"
                id="deleteButton"
                @keyup.enter="onTrashCharge(charges?.data[selectedCharge]?.Id, charges?.data[selectedCharge])"
                @click="onTrashCharge(charges?.data[selectedCharge]?.Id, charges?.data[selectedCharge])"
              >
                Delete Charge
              </button>
            </div>
            <div>
              <button class="btn btn-primary-outline btn-xl" @click="showDeleteChargePopup = false">Cancel</button>
            </div>
          </div>
        </div>
      </template>
      <template></template>
    </Modal>

    <Modal v-if="editCaseInfoPanelVisible">
      <!-- <template v-slot:header >
            <div style="width:50%">
                <h2>Edit Case</h2>
            </div>
        </template> -->

      <template v-slot:body>
        <div style="width: 50%" class="center">
          <EditCase :app_token="app_token" :newCaseFlag="false" :currentCase="selectedCase" @closeEditCase="closeEditCase" />
        </div>
      </template>
      <!-- <template v-slot:footer>
            <div class="d-flex justify-content-evenly">
                <button class="btn btn-primary" @click="closeEditCase">Close</button>
            </div>
        </template> -->
    </Modal>

    <transition name="fade" style="z-index: 1000">
      <Modal v-if="popup !== null" @close="popup = null" :big="popup == 'Consequences'">
        <template v-slot:header>
          <span class="d-flex flex-row justify-content-between col-12 align-items-center">
            <div style="width: 57px"></div>
            <h2 class="fs-3 fw-bold">{{ popup }}</h2>
            <button class="btn btn-gray btn-xl ml-3" @click="popup = null">
              <i class="fa fa-close"></i>
            </button>
          </span>
        </template>
        <template v-slot:body>
          <CountNumberFixer
            v-if="popup == 'Adjust Count Numbers'"
            :charges="charges.data"
            @close="popup = null"
            @onCalc="onCalc"
            @insertChargeBetweenCounts="insertChargeBetweenCounts"
          />
          <UpdateMultipleCharges
            v-if="popup == 'Edit Multiple Charges'"
            :charges="charges.data"
            :caseId="currentCase?.Id"
            @onTrashCharge="onTrashCharge"
            @displayModalPopup="displayModalPopup"
            @refreshCharges="mount"
            @onCalc="onCalc"
            @mount="mount"
          />
          <SexSentencing
            v-if="popup == 'Sex Sentencing'"
            :key="selectedCharge"
            :selectedCharge="selectedCharge"
            :user_token="app_token"
            :chargesData="charges.data"
            :selectedCase="selectedCase"
            :victims="victims"
            @selectCharge="selectCharge"
            @onCalc="onCalc"
          ></SexSentencing>
          <Factors
            v-else-if="popup == 'Case Settings'"
            :charges="charges.data"
            :caseSelected="selectedCase"
            :user_token="user_token"
            :selectedCharge="selectedCharge"
            @refreshCharges="mount"
            @onCalc="onCalc"
            @selectCharge="selectCharge"
            @executeStrike0="executeStrike0"
            @executeStrike1="executeStrike1"
            @executeStrike2="executeStrike2"
            @executeSuperStrike="executeSuperStrike"
            @displayModalPopup="displayModalPopup"
          />
          <Circumstances
            :caseSelected="selectedCase"
            :caseCircumstances="caseCircumstances"
            @popupText="displayModalPopup"
            @generateReport="generateCircumstancesReport"
            v-else-if="popup == 'Circumstances'"
          />
          <NewProbation
            v-else-if="popup == 'Probation'"
            :charges="charges.data"
            :selectedCase="selectedCase"
            :ProbationLimitations="ProbationLimitations"
            :probationFactors="ProbationFactors"
            :caseProbationLimitations="CaseProbationLimitations"
            :caseProbationFactors="CaseProbationFactors"
            @selectCharge="selectCharge"
            @displayModalPopup="displayModalPopup"
            @addChargeFromPopup="postCharge"
            @onCalc="onCalc()"
            @generateProbationReport="generateProbationReport"
          ></NewProbation>
          <JuryInstructions
            v-else-if="popup == 'Charge Specific Jury Instructions'"
            :charges="charges.data"
            :caseJuryInstructions="juryInstructions"
            :selectedCase="selectedCase"
            @displayJuryInstructionsPopup="displayJuryInstructionsPopup"
          >
          </JuryInstructions>
          <CPKSelector
            v-else-if="popup == 'Charge Details Selector'"
            :charges="charges.data"
            :user_token="app_token"
            :caseId="selectedCase.Id"
            :selectedChg="selectedCharge"
            @refreshCharges="reload"
          >
          </CPKSelector>
          <AddCharge
            v-else-if="popup == 'Add Enhancement'"
            :chargeToAdd="addChargeObject?.chargeToAdd"
            :chargeToEnhance="charges.data[selectedCharge]"
            :countNumber="charges.data[selectedCharge]?.CountNumber"
            :helpText="addChargeObject?.helpText"
            :caseId="addChargeObject?.caseId"
            @addChargeFromPopup="postCharge"
          >
          </AddCharge>
          <JailTime
            v-else-if="popup == 'Jail Time'"
            :charges="charges.data"
            :selectedCase="selectedCase"
            :selectedCharge="selectedCharge"
            @onCalc="onCalc"
          ></JailTime>

          <!-- <CrimeDetails v-else-if="popup == 'Crime Details'" :chg="charges.data[selectedCharge]"
            :user_token="app_token">
          </CrimeDetails> -->
          <RuleWords
            v-else-if="popup == 'Sentencing Rules'"
            :user_token="app_token"
            :selectedCase="selectedCase"
            :charge="charges.data[selectedCharge]"
            :ruleWords="charges.data[selectedCharge]?.newExposureObject?.populatedRuleWords"
          ></RuleWords>
          <!-- REPORTS -->
          <div
            class="d-flex row col-lg-12 mob-col m-0 p-0 justify-content-evenly"
            style="min-width: 30vw"
            v-else-if="popup == 'Reports'"
          >
            <div class="d-flex flex-column card col-12 px-0 mob-mb-2" style="min-height: 310px">
              <div class="d-flex card-body mob-col flex-column scrollable">
                <div class="d-flex align-items-center mb-0">
                  <button
                    class="btn btn-xl btn-primary-outline mr-3"
                    v-if="!allReportOptionsChecked"
                    @click="
                      toggleAllreportOptions(true);
                      reportOptionsAll = true;
                    "
                  >
                    Check All
                  </button>
                  <button
                    v-else
                    class="btn btn-xl btn-primary-outline"
                    @click="
                      toggleAllreportOptions(false);
                      reportOptionsAll = false;
                    "
                  >
                    Uncheck All
                  </button>
                  <!-- <input ref="AllReportOptions" v-model="reportOptionsAll"
                    @input="toggleAllreportOptions(!reportOptionsAll)" class="mr-3" type="checkbox"
                    id="AllReportOptions" />

                  <label class="fs-5 mt-0 pl-1 clickable mb-0" for="AllReportOptions">Select All</label> -->
                </div>

                <ul class="p-0 d-flex flex-column flex-wrap col-12">
                  <!-- <p class="fs-6 fw-bold">Sentencing Options</p> -->
                  <li style="list-style: none" class="d-flex align-items-center mb-3">
                    <input type="checkbox" class="mr-3" id="coverPage" v-model="reportOptions.coverPage" />

                    <label class="fs-5 mt-0 pl-1 clickable mb-0" for="coverPage">Cover Page</label>
                  </li>
                  <li style="list-style: none" class="d-flex align-items-center mb-3">
                    <input
                      ref="ExposureCalculationReport"
                      v-model="reportOptions.exposure"
                      class="mr-3"
                      type="checkbox"
                      id="Exposure"
                    />

                    <label class="fs-5 mt-0 pl-1 clickable mb-0" for="Exposure">Incarceration Summary</label>
                  </li>
                  <li style="list-style: none" class="d-flex align-items-center mb-3">
                    <input
                      ref="Credits/Release"
                      v-model="reportOptions.releaseDate"
                      class="mr-3"
                      type="checkbox"
                      id="Credits/Release"
                    />

                    <label class="fs-5 mt-0 pl-1 clickable mb-0" for="Credits/Release">Credits/Release Date</label>
                  </li>
                  <li style="list-style: none" class="d-flex align-items-center mb-3">
                    <input
                      ref="ReportCrimeDetails"
                      v-model="reportOptions.crimeDetails"
                      class="mr-3"
                      type="checkbox"
                      id="ReportCrimeDetails"
                    />

                    <label class="fs-5 mt-0 pl-1 clickable mb-0" for="ReportCrimeDetails">Crime Details</label>
                  </li>
                  <li style="list-style: none" class="d-flex align-items-center mb-3">
                    <input
                      ref="CaseDetailsReport"
                      v-model="reportOptions.caseDetails"
                      class="mr-3"
                      type="checkbox"
                      id="ReportCaseDetails"
                    />

                    <label class="fs-5 mt-0 pl-1 clickable mb-0" for="ReportCaseDetails">Collateral Consequences</label>
                  </li>

                  <li style="list-style: none" class="d-flex align-items-center mb-3">
                    <input
                      ref="probationEligibility"
                      v-model="reportOptions.probationEligibility"
                      class="mr-3"
                      type="checkbox"
                      id="probationEligibility"
                    />

                    <label class="fs-5 mt-0 pl-1 clickable mb-0" for="probationEligibility">Probation</label>
                  </li>
                  <li
                    style="list-style: none"
                    class="d-flex align-items-center mb-3"
                    v-if="reportOptions?.probationEligibility"
                  >
                    <input
                      ref="probationFactors"
                      v-model="reportOptions.probationFactors"
                      class="mr-3"
                      type="checkbox"
                      id="probationFactors"
                    />

                    <label class="fs-5 mt-0 pl-1 clickable mb-0" for="probationFactors">Probation Findings Checklist</label>
                  </li>
                  <li style="list-style: none" class="d-flex align-items-center mb-3">
                    <input
                      ref="CircumstancesReport"
                      v-model="reportOptions.circumstances"
                      class="mr-3"
                      type="checkbox"
                      id="CircumstancesReport"
                    />

                    <label class="fs-5 mt-0 pl-1 clickable mb-0" for="CircumstancesReport">Circumstances</label>
                  </li>
                  <li style="list-style: none" class="d-flex align-items-center mb-3">
                    <input
                      ref="ElementsReport"
                      v-model="reportOptions.elements"
                      class="mr-3"
                      type="checkbox"
                      id="ElementsReport"
                    />

                    <label class="fs-5 mt-0 pl-1 clickable mb-0" for="ElementsReport">Elements</label>
                  </li>
                  <li style="list-style: none" class="d-flex align-items-center mb-3">
                    <input
                      ref="ExposureTextCalculationReport"
                      v-model="reportOptions.exposureTextCase"
                      class="mr-3"
                      type="checkbox"
                      id="ExposureText"
                    />

                    <label class="fs-5 mt-0 pl-1 clickable mb-0" for="ExposureText">Punishment Text</label>
                  </li>
                  <li style="list-style: none" class="d-flex align-items-center mb-3">
                    <input
                      ref="ElementsReport"
                      v-model="reportOptions.definitionTextCase"
                      class="mr-3"
                      type="checkbox"
                      id="StatueText"
                    />

                    <label class="fs-5 mt-0 pl-1 clickable mb-0" for="StatueText">Statute Text</label>
                  </li>
                  <a class="btn btn-primary btn-xl my-3" v-if="!loading" @click="generateReport" href="#">Generate Report</a>
                </ul>
              </div>
            </div>
          </div>

          <!-- CREDITS -->
          <!-- <div class="w-100 d-flex flex-wrap" v-else-if="popup == 'Custody Credits'">
            <div class="mb-5 col-12 col-lg-7">
              <div class="card p-0 p-0 p-0">
                <div class="card-header fs-5 fw-bold py-1">
                  <p class="m-0 fs-3">Presentence Credits</p>
                </div>
                <div class="card-body p-0 overflow-auto">
                  <CreditRelease
                    @updateCredits="updateCredits"
                  >
                  </CreditRelease>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-5">
              <div class="card d-flex p-0 flex-column">
                <div class="card-header py-1 border-bottom">
                  <p class="m-0 fs-3 fw-bold">Credits Earned</p>
                </div>
                <div class="card-body p-0 overflow-auto">
                  <table class="fs-5 table border-0">
                    <thead>
                      <th class="fw-bold pl-5">Actual Time</th>
                      <th class="fw-bold">Credit Ratio</th>
                      <th class="fw-bold">Conduct Credits</th>
                      <th class="fw-bold">Total</th>
                    </thead>

                    <tbody v-if="creditDayArray?.length > 0">
                      <tr v-for="(daysObj, i) in creditDayArray" :key="i">
                        <td class="pl-5" style="margin-bottom: 2px;">
                          {{ (daysObj?.daysServed).toLocaleString() }}
                        </td>
                        <td class="">{{ daysObj?.rate }}%</td>
                        <td class="">
                          {{ (daysObj?.creditDays).toLocaleString() }}
                        </td>
                        <td class="">
                          {{
                            (daysObj?.daysServed + daysObj.creditDays).toLocaleString()
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table class="fs-5 table border-0">
                    <tbody class="">
                      <tr>
                        <td class="fw-bold p-3 border-0">Actual Time Served</td>
                        <td class="p-3 border-0">
                          {{
                            vueNumberFormat(crData?.actualDaysTotal || 0, {
                              prefix: "",
                              acceptNegative: false,
                              isInteger: false,
                              decimal: "",
                              precision: 0,
                              thousand: ",",
                            })
                          }}
                          days
                        </td>
                      </tr>
                      <tr>
                        <td class="fw-bold p-3 border-0">Conduct Credit</td>
                        <td class="p-3">
                          {{
                            vueNumberFormat(crData?.conductCredit || 0, {
                              prefix: "",
                              acceptNegative: false,
                              isInteger: false,
                              decimal: "",
                              precision: 0,
                              thousand: ",",
                            })
                          }}
                          days
                        </td>
                      </tr>
                      <tr></tr>
                    </tbody>
                    <tfoot class="border-0">
                      <tr>
                        <td class="fw-bold p-3">Total Credit</td>
                        <td class="p-3">
                          {{
                            vueNumberFormat(crData?.totalCredit || 0, {
                              prefix: "",
                              acceptNegative: false,
                              isInteger: false,
                              decimal: "",
                              precision: 0,
                              thousand: ",",
                            })
                          }}
                          days
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div> -->
        </template>
        <template v-slot:footer> </template>
      </Modal>
    </transition>
    <Modal
      v-if="showGenerateReportModal"
      size="medium"
      @close="
        showGenerateReportModal = false;
      "
    >
      <template v-slot:header>
        <div class="d-flex justify-content-between w-100">
          <div></div>
          <h3 class="fs-3 fw-bold">Create Reports</h3>
          <button
            class="btn btn-gray"
            @click="
              showGenerateReportModal = false;
              clearURLQueryParams();
            "
          >
            <i class="fa fa-close"></i>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <div class="d-flex px-5">
          <div class="d-flex card-body flex-column">
            <!-- <h3 class="fs-3 fw-bold">Report Types</h3> -->
            <div class="d-flex align-items-center mb-3">
              <button class="btn btn-xl btn-primary-outline mt-3" @click="toggleAllreportOptions(!allReportOptionsChecked)">
                {{ allReportOptionsChecked ? "Uncheck All" : "Select All" }}
              </button>
            </div>

            <!-- <ul class="list-unstyled p-0">
              <li class="d-flex align-items-center mb-3" style="list-style: none;">
                <input ref="ExposureCalculationReport" v-model="reportOptions.exposure" type="checkbox" id="Exposure" class="me-2" />

                <div class="flex-grow-1">
                  <input v-if="showIncarcerationSummaryInput" type="text" class="form-control pl-1" v-model="reportOptions.moduleReportNames.incarcerationSummaryName" :placeholder="'Incarceration Summary'" @blur="showIncarcerationSummaryInput = false" />

                  <label v-else for="Exposure" class="fs-5 mb-0 pl-2">
                    {{ 'Incarceration Summary' }}
                  </label>
                </div>

                <span class="ms-2 clickable pl-2">
                  <i v-if="!showIncarcerationSummaryInput" class="fa fa-pencil" @click="showIncarcerationSummaryInput = true"></i>
                  <i v-else class="fa fa-check text-success" @click=""></i>
                </span>

                <i v-if="showIncarcerationSummaryInput" class="fa fa-cancel ms-2 clickable pl-2" @click="showIncarcerationSummaryInput = false"></i>
              </li>
            </ul> -->

            <ul class="d-flex flex-column flex-wrap p-0 mt-1">
              <!-- <p class="fs-6 fw-bold">Sentencing Options</p> -->

              <li style="list-style: none" class="d-flex align-items-center mb-3">
                <input type="checkbox" class="mr-3" id="coverPage" v-model="reportOptions.coverPage" />

                <label class="fs-5 mt-0 pl-1 clickable mb-0" for="coverPage">Cover Page</label>
              </li>
              <li style="list-style: none" class="d-flex align-items-center mb-3">
                <input
                  ref="ExposureCalculationReport"
                  v-model="reportOptions.exposure"
                  class="mr-3"
                  type="checkbox"
                  id="Exposure"
                />

                <label class="fs-5 mt-0 pl-1 clickable mb-0" for="Exposure">Incarceration Summary</label>
              </li>
              <li style="list-style: none" class="d-flex align-items-center mb-3">
                <input
                  ref="Credits/Release"
                  v-model="reportOptions.releaseDate"
                  class="mr-3"
                  type="checkbox"
                  id="Credits/Release"
                />

                <label class="fs-5 mt-0 pl-1 clickable mb-0" for="Credits/Release">Custody Credits & Release Date</label>
              </li>
              <!-- <li style="list-style: none" class="d-flex align-items-center mb-3">
                  <input ref="ReportCrimeDetails" v-model="reportOptions.crimeDetails" class="mr-3" type="checkbox"
                    id="ReportCrimeDetails" />

                  <label class="fs-5 mt-0 pl-1 clickable mb-0" for="ReportCrimeDetails">Crime Details (New!)</label>
                </li> -->
              <li style="list-style: none" class="d-flex align-items-center mb-3">
                <input
                  ref="CaseDetailsReport"
                  v-model="reportOptions.caseDetails"
                  class="mr-3"
                  type="checkbox"
                  id="ReportCaseDetails"
                />

                <label class="fs-5 mt-0 pl-1 clickable mb-0" for="ReportCaseDetails">Collateral Consequences</label>
              </li>

              <li style="list-style: none" class="d-flex align-items-center mb-3">
                <input
                  ref="probationEligibility"
                  v-model="reportOptions.probationEligibility"
                  class="mr-3"
                  type="checkbox"
                  id="probationEligibility"
                />

                <label class="fs-5 mt-0 pl-1 clickable mb-0" for="probationEligibility">Probation</label>
              </li>
              <li style="list-style: none" class="d-flex align-items-center mb-3" v-if="reportOptions?.probationEligibility">
                <input
                  ref="probationFactors"
                  v-model="reportOptions.probationFactors"
                  class="mr-3"
                  type="checkbox"
                  id="probationFactors"
                />

                <label class="fs-5 mt-0 pl-1 clickable mb-0" for="probationFactors">Probation Findings Checklist</label>
              </li>
              <li style="list-style: none" class="d-flex align-items-center mb-3">
                <input
                  ref="CircumstancesReport"
                  v-model="reportOptions.circumstances"
                  class="mr-3"
                  type="checkbox"
                  id="CircumstancesReport"
                />

                <label class="fs-5 mt-0 pl-1 clickable mb-0" for="CircumstancesReport"
                  >Factors in Aggravation & Mitigation</label
                >
              </li>
              <li style="list-style: none" class="d-flex align-items-center mb-3">
                <input
                  ref="ElementsReport"
                  v-model="reportOptions.elements"
                  class="mr-3"
                  type="checkbox"
                  id="ElementsReport"
                />

                <label class="fs-5 mt-0 pl-1 clickable mb-0" for="ElementsReport">Elements</label>
              </li>
              <li style="list-style: none" class="d-flex align-items-center mb-3">
                <input
                  ref="ExposureTextCalculationReport"
                  v-model="reportOptions.exposureTextCase"
                  class="mr-3"
                  type="checkbox"
                  id="ExposureText"
                />

                <label class="fs-5 mt-0 pl-1 clickable mb-0" for="ExposureText">Punishment Text</label>
              </li>
              <li style="list-style: none" class="d-flex align-items-center mb-3">
                <input
                  ref="ElementsReport"
                  v-model="reportOptions.definitionTextCase"
                  class="mr-3"
                  type="checkbox"
                  id="StatueText"
                />

                <label class="fs-5 mt-0 pl-1 clickable mb-0" for="StatueText">Statute Text</label>
              </li>
              <!-- <li style="list-style: none" class="d-flex align-items-center mb-3">
                <input v-model="reportOptions.excludeNonConvictedCrimes" class="mr-3" type="checkbox"
                  id="excludeNonConvictedCrimes" />

                <label class="fs-5 mt-0 pl-1 clickable mb-0" for="excludeNonConvictedCrimes">Exclude Non-Convicted
                  Crimes</label>
              </li> -->
              <div>
                <button class="btn btn-primary btn-xl my-3" v-if="!loading" @click="generateReport">Generate Report</button>
                <LoadingButton v-else class="my-3" style="height: 36.6px"></LoadingButton>
              </div>
            </ul>
          </div>
          <div v-if="caseStore?.selectedCaseScenarios?.length > 0" class="d-flex flex-column pl-5 ml-5">
            <h3 class="fs-4 fw-bold mb-1">Report Settings</h3>
            <div class="pl-2">
              <span class="fs-5 d-flex flex-column"> Choose scenario:</span>
              <select class="form-control-lg mb-2 fs-5" v-model="caseStore.selectedCaseId" @change="changeScenarioName">
                <option :value="caseStore.selectedCaseParentCaseId" :key="`main-${caseStore?.selectedCaseParentCaseId}`">
                  {{ "Original Case" }}
                </option>

                <option v-for="sc in caseStore?.selectedCaseScenarios" :key="sc.Id" :value="sc.Id">
                  {{ sc?.ScenarioName }}
                </option>
              </select>
            </div>
            <li
              v-if="caseStore.selectedCaseScenarios.length > 0 && isMainCase === false"
              style="list-style: none"
              class="d-flex align-items-center mb-3"
            >
              <input
                type="checkbox"
                class="mr-3"
                id="includeScenarioTitle"
                v-model="reportOptions.includeScenarioTitle"
              />
              <label class="fs-5 mt-0 clickable mb-0" for="includeScenarioTitle">Print Scenario Name</label>
            </li>
          </div>
        </div>
      </template>
      <template v-slot:footer></template>
    </Modal>
    <Crimes
      :app_attr="app_attr"
      :noActivity="noActivity"
      :key="selectedCase?.Id"
      v-if="showCrimesTable"
      :app_token="app_token"
      @displayModalPopup="displayModalPopup"
      @addChargesFromCrimeTable="addChargesFromCrimeTable"
      @close="showCrimesTable = false"
      :currentCount="currentCount"
      :insertChargeCountNumber="insertChargeCountNumber"
      :charges="charges.data || []"
    />
    <!-- <div class="col-12 p-0 m-0 d-flex justify-content-center overflow-hidden">
      <div class="col-md-12 px-0 d-flex justify-content-center px-lg-5"> -->
    <div class="d-flex flex-wrap h-100">
      <div class="d-flex flex-column col-12 col-lg-2 px-0">
        <div class="card">
          <!-- <div
            class="card-header d-flex justify-content-between w-100 align-items-center"
          >
            <h3 class="section-header fw-bold pl-5 pt-3">Menu</h3>
            <div class="mob-show">
              <i
                class="fa fs-3 pr-5"
                :class="showMenuOptions ? 'fa-chevron-up' : 'fa-chevron-down'"
                @click="showMenuOptions = !showMenuOptions"
              ></i>
            </div>
          </div> -->
          <div class="w-100">
            <div class="d-flex justify-content-between align-items-center pl-5" style="min-height: 66px">
              <router-link to="/Cases">
                <button class="btn btn-primary-outline btn-lg fw-bold">
                  <i class="fa fa-chevron-left"></i>
                  Case List
                </button>
              </router-link>
              <button class="btn btn-primary btn-xl mr-3" @click="showManageScenariosModal = true">Scenarios</button>
              <div class="mob-show">
                <i
                  class="fa fs-3 pr-5"
                  :class="showMenuOptions ? 'fa-chevron-up' : 'fa-chevron-down'"
                  @click="showMenuOptions = !showMenuOptions"
                ></i>
              </div>
            </div>
          </div>
          <div
            class="card-body p-0 d-flex flex-column border-left border-right border-top"
            :class="!showMenuOptions ? 'tab-hidden' : ''"
          >
            <!-- <button class="btn btn-primary btn-xl  control-btn mr-lg-3"
                            @click="togglePopup('Case Settings')">
                            
                          </button>
                          <button class="btn btn-primary btn-xl  control-btn mr-lg-3"
                            @click="togglePopup('Circumstances')">
                            
                          </button>
                          <button class="btn btn-primary btn-xl  control-btn mr-lg-3"
                            @click="togglePopup('Custody Credits')">
                            
                          </button>
                          <button class="btn btn-primary btn-xl  control-btn mr-lg-3"
                            @click="togglePopup('Release Date')">
                            
                          </button>
                          <button class="btn btn-primary btn-xl  control-btn mr-lg-3" @click="togglePopup('Probation')">
                            
                          </button>
                          <button class="btn btn-primary btn-xl  control-btn mr-lg-3"
                            @click="togglePopup('Charge Specific Jury Instructions')">
                            
                          </button>
                          
                          <button class="btn btn-primary btn-xl px-4 control-btn" @click="togglePopup('Reports')">
                            
                          </button> -->

            <div
              class="w-100 selectable charge-details-menu-options charge-details-menu-options-1 fs-4 px-5 border-bottom"
              :class="mode == 'Charges' ? 'selected' : ''"
              @click="mode = 'Charges'"
            >
              <div>
                <!-- <i class="fa fa-bolt"></i> -->
                Charges
              </div>
              <i class="fa fa-chevron-right fs-5"></i>
            </div>
            <div
              class="w-100 selectable charge-details-menu-options fs-4 px-5 border-bottom"
              :class="mode == 'Case Settings' ? 'selected' : ''"
              @click="mode = 'Case Settings'"
            >
              <div>
                <!-- <i class="fa fa-gear"></i> -->
                Tools & Settings
              </div>
              <i class="fa fa-chevron-right fs-5"></i>
            </div>
            <div
              class="w-100 selectable charge-details-menu-options fs-4 px-5 border-bottom"
              :class="mode == 'Circumstances' ? 'selected' : ''"
              @click="mode = 'Circumstances'"
            >
              <div>
                <!-- <i class="fa-solid fa-scale-unbalanced-flip"></i> -->
                Aggravation & Mitigation
              </div>
              <i class="fa fa-chevron-right fs-5"></i>
            </div>
            <div
              class="w-100 selectable charge-details-menu-options fs-4 px-5 border-bottom"
              :class="mode == 'Custody Credits' ? 'selected' : ''"
              @click="mode = 'Custody Credits'"
            >
              <div>
                <!-- <i class="fa fa-coins"></i> -->
                Custody Credits
              </div>
              <i class="fa fa-chevron-right fs-5"></i>
            </div>
            <div
              class="w-100 selectable charge-details-menu-options fs-4 px-5 border-bottom"
              :class="mode == 'Release Date' ? 'selected' : ''"
              @click="mode = 'Release Date'"
            >
              <div>
                <!-- <i class="fa fa-calendar"></i> -->
                Release Date
              </div>
              <i class="fa fa-chevron-right fs-5"></i>
            </div>
            <div
              class="w-100 selectable charge-details-menu-options fs-4 px-5 border-bottom"
              :class="mode == 'Probation' ? 'selected' : ''"
              @click="mode = 'Probation'"
            >
              <div>
                <!-- <i class="fa fa-shield-halved"></i> -->
                Probation Eligibility
              </div>
              <i class="fa fa-chevron-right fs-5"></i>
            </div>
            <div
              class="w-100 selectable charge-details-menu-options fs-4 px-5 border-bottom"
              :class="mode == 'Jury Instructions' ? 'selected' : ''"
              @click="mode = 'Jury Instructions'"
            >
              <div>
                <!-- <i class="fa fa-user"></i> -->
                Jury Instructions
              </div>
              <i class="fa fa-chevron-right fs-5"></i>
            </div>
            <!-- <div
              class="w-100 selectable charge-details-menu-options fs-4 px-5 border-bottom"
              :class="mode == 'Reports' ? 'selected' : ''"
              @click="mode = 'Reports'"
            >
              <div>
                Reports
              </div>
              <i class="fa fa-chevron-right fs-5"></i>
            </div> -->
          </div>
          <div class="d-flex pl-5 mt-3">
            <button
              class="btn btn-primary"
              @click="
                showGenerateReportModal = true;
              "
            >
              Create Reports
            </button>
          </div>
        </div>
      </div>

      <!-- Case Details Title  -->
      <div class="d-flex justify-content-center tab-col mt-5 m-lg-0 p-0 flex-wrap col-12 col-lg-10 h-100 overflow-auto">
        <div class="col-12 px-0 d-flex h-100" v-if="mode == 'Charges'">
          <div class="d-flex flex-column justify-content-between w-100 h-100 p-0">
            <div class="d-flex flex-column justify-content-start w-100 table-container p-0">
              <div class="fs-6 fw-bold">
                <div class="d-flex justify-content-between align-items-center flex-wrap" style="min-height: 66px">
                  <div class="d-flex align-items-center">
                    <h3 v-if="loading == false || this.selectedCase != null" class="section-header fw-bold pl-5 py-3">
                      Charges
                      <span v-if="selectedCase?.DefendantFirstName || selectedCase?.DefendantLastName">
                        | {{ selectedCase?.DefendantFirstName }}
                        {{ selectedCase?.DefendantLastName }}
                        <span v-if="selectedCase?.CaseNumber">, Case # {{ selectedCase?.CaseNumber }}</span>
                      </span>
                      <span v-if="caseStore.selectedCaseScenarios.length > 0 && scenarioName != null">
                        | Scenario: {{ scenarioName }}
                      </span>
                    </h3>
                  </div>
                  <div></div>

                  <div>
                    <div class="d-flex align-items-center">
                      <div class="d-flex align-items-center mx-5" v-if="selectedCase != null">
                        <label for="strikes" class="fs-5 fw-bold mr-3">Prior Strikes:</label>
                        <select
                          name="strikes"
                          id="strikes"
                          class="form-control"
                          @change="executeStrikeFromCase"
                          v-model="selectedCase.NumberOfStrikes"
                        >
                          <option :value="0">0 Strikes</option>
                          <option :value="1">1 Strike</option>
                          <option :value="2">2+ Strikes</option>
                          <option :value="3">2+ w/ Super Strike</option>
                        </select>
                      </div>

                      <button class="btn btn-primary btn-xl px-4 mr-5" @click="onAddCharge">
                        <i class="fa fa-plus mr-3"></i>
                        Add Charge
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-body m-0 p-0 d-flex flex-column align-items-center w-100 justify-content-between w-100">
                <div class="w-100 scrollable d-flex">
                  <table class="table w-100 mb-0 border-right border-left-0">
                    <thead class="border-top border-bottom border-left" style="z-index: 10">
                      <tr class="bg-primary m-0 p-0" style="z-index: 80">
                        <CDHOffense :row="3" :toggleView="toggleView" :detailedView="detailedView" />
                        <CDHIncarceration
                          :currentCase="selectedCase"
                          :row="3"
                          :toggleView="toggleView"
                          @onStrikeChange="onStrikeChange"
                          :detailedView="detailedView"
                        />
                      </tr>
                    </thead>

                    <tbody class="border-left-0">
                      <tr
                        v-for="(chg, chgIndex) in charges.data"
                        :key="chgIndex"
                        @click="selectCharge(chgIndex)"
                        style="z-index: 1"
                        class="clickable border-top-0 selectable border-left-0"
                        :class="{
                          selected: chgIndex == selectedCharge,
                        }"
                      >
                        <!-- OFFENSE START -->
                        <CDBOffense
                          :charges="charges"
                          :app_attr="app_attr"
                          :chg="chg"
                          :toggleView="toggleView"
                          @displayModalPopup="displayModalPopup"
                          @onCalc="onCalc"
                          @refreshCharges="mount(false)"
                          :principalTies="principalTies"
                          @selectedCharge="selectCharge(chargeIndex)"
                          @toggleCPKPicker="popup = 'Charge Details Selector'"
                          :app_token="app_token"
                          :detailedView="detailedView"
                          @click="selectCharge(chgIndex)"
                          :hideBorderTop="
                            chgIndex !== 0 &&
                            (charges.data[chgIndex - 1]?.CrimeTypeId == 6 || charges.data[chgIndex - 1]?.CrimeTypeId == 2) &&
                            (chg?.CrimeTypeId == 6 || chg?.CrimeTypeId == 2)
                          "
                          :showBorderLeft="chg?.CrimeTypeId !== 6 && chg?.CrimeTypeId !== 2"
                        />
                        <!-- OFFENSE END -->

                        <!-- Incarceration -->
                        <CDBIncarceration
                          :chg="chg"
                          :toggleView="toggleView"
                          :app_token="app_token"
                          :currentCase="selectedCase"
                          @onCalc="onCalc()"
                          @displayLawText="displayLawText"
                          style="z-index: 2"
                          @displayModalPopup="displayModalPopup"
                          :noActivity="noActivity"
                          :charges="charges.data"
                          @emitGangEnhancement="toggleAddCrimePopup"
                          @jailTimePopup="jailTimePopup"
                          @ruleWordsPopup="toggleRuleWordsPopup"
                          :detailedView="detailedView"
                        />

                        <td
                          class="m-0 mx-0 p-0 py-2 ta-c border-top"
                          :class="chg.Id == charges.data[charges.data.length - 1].Id ? 'border-bottom' : ''"
                        >
                          <button
                            v-if="chg.Name != '-- Empty --'"
                            class="btn btn-primary-outline btn-lg text-center"
                            @click="toggleShowDelete(chg)"
                            style="width: 60px"
                          >
                            <i class="fa fa-trash fs-3" aria-hidden="true"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="container-box w-100 pl-0 d-flex justify-content-between flex-wrap overflow-auto border-top mb-5">
              <div class="card col-12 col-lg-8 p-0" v-if="!detailedView">
                <!-- <div class=" fw-bold py-2 px-3 card-header">
                        <div class="d-flex justify-content-between align-items-center">
                          <div style="width: 62px"></div>
                          <p class="m-0 fs-3" style="text-align-center">Details</p>
                          <button class="btn btn-primary btn-xl" @click="selectedCharge = null">
                            <i class="fa fa-close fs-5"></i>
                          </button>
                        </div>
                      </div> -->
                <div
                  class="card-body p-0 border-right h-100 overflow-auto"
                  :class="selectedCharge == null ? 'border-bottom  border-left' : ''"
                >
                  <p class="fs-5 p-5" v-if="selectedCharge == null">Select a charge by clicking in the charge list.</p>
                  <CDBWorkspace
                    v-else
                    @displayModalPopup="displayModalPopup"
                    @refreshCharges="mount(false)"
                    @calc="onCalc"
                    @factorSelect="popup = 'Charge Details Selector'"
                    @selectPrincipal="selectPrincipal"
                    :principalTies="principalTies"
                    :charges="charges"
                    :charge="charges.data[selectedCharge]"
                  >
                  </CDBWorkspace>
                </div>
              </div>
              <div class="card col-12 col-lg-4 p-0 border-right border-bottom" v-if="charges.data?.length > 0">
                <div class="card-header">
                  <h3 class="section-header fw-bold pl-5 py-3">Selected Sentence</h3>
                </div>
                <div class="d-flex flex-column p-0 m-0">
                  <table class="w-100 border-0 m-0 p-0">
                    <tbody class="" v-if="charges?.data?.length > 0">
                      <tr class="border-top">
                        <td class="fs-5 py-3 px-5 fw-bold">Probation Eligibility</td>
                        <td class="fs-5 py-3 px-5 ta-r">
                          <span v-if="!probationEligibility.Eligible">Ineligible</span>
                          <span
                            v-else-if="
                              probationEligibility.Unusual || probationEligibility.SpecialA || probationEligibility.SpecialB
                            "
                            >Eligible with Findings</span
                          >
                          <span v-else>Eligible</span>
                        </td>
                      </tr>
                      <tr v-if="exposureDaysMisdemeanor">
                        <td class="fs-5 py-3 px-5 fw-bold">Misdemeanor</td>
                        <td class="fs-5 py-3 px-5 ta-r">{{ exposureDaysMisdemeanor }}d</td>
                      </tr>
                      <tr v-if="displayExposureObject(formattedExposure.totalDeterminate)">
                        <td class="fs-5 py-3 px-5 fw-bold">Determinate</td>
                        <td class="fs-5 py-3 px-5 ta-r">
                          {{ displayExposureObject(formattedExposure.totalDeterminate) }}
                        </td>
                      </tr>
                      <tr v-if="formattedExposure.totalIndeterminate?.rawDays">
                        <td class="fs-5 py-3 px-5 fw-bold">Indeterminate</td>
                        <td class="fs-5 py-3 px-5 ta-r">
                          {{ parseDays(false, formattedExposure.totalIndeterminate?.rawDays).exp || 0 }}
                          - L
                        </td>
                      </tr>

                      <tr>
                        <td class="fs-5 py-3 px-5 fw-bold">Total</td>
                        <td class="fs-5 py-3 px-5 ta-r">
                          <span v-if="exposureDaysMisdemeanor">{{ exposureDaysMisdemeanor }}d</span>
                          <span
                            v-if="
                              exposureDaysMisdemeanor &&
                              (formattedExposure.totalDeterminate?.rawDays || formattedExposure.totalIndeterminate?.rawDays)
                            "
                          >
                            +
                          </span>
                          <span v-if="formattedExposure.totalDeterminate?.rawDays"
                            >{{ displayExposureObject(formattedExposure.totalDeterminate) }}
                          </span>
                          <span
                            v-if="
                              formattedExposure.totalIndeterminate?.rawDays && formattedExposure.totalDeterminate?.rawDays
                            "
                          >
                            +
                          </span>
                          <span v-if="formattedExposure.totalIndeterminate?.rawDays"
                            >{{ parseDays(false, formattedExposure.totalIndeterminate?.rawDays).exp || 0 }} - L</span
                          >
                        </td>
                      </tr>
                      <tr v-if="specialIndeterminate">
                        <td class="fs-5 py-3 px-5 fw-bold">Other</td>
                        <td class="fs-5 py-3 px-5 ta-r">
                          <span>{{ specialIndeterminate }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 px-0 pt-3 d-flex" v-if="mode == 'Circumstances'">
          <Circumstances
            :caseSelected="selectedCase"
            :caseCircumstances="caseCircumstances"
            @popupText="displayModalPopup"
            @generateReport="generateCircumstancesReport"
          />
        </div>
        <div class="col-12 px-0 pt-3 d-flex flex-column" v-if="mode == 'Custody Credits'">
          <h1 class="section-header fw-bold pl-5">Custody Credits</h1>
          <div class="w-100 d-flex flex-wrap">
            <div class="mb-5 col-12 col-lg-5 p-0">
              <div class="card p-0 p-0 p-0">
                <div class="card-header fs-5 fw-bold py-1">
                  <p class="m-0 fs-3 pl-5">Presentence Credits</p>
                </div>
                <div class="card-body p-0 overflow-auto">
                  <CreditRelease @updateCredits="updateCredits" :cr_release_data="selectedCase?.caseAttributes?.crData">
                  </CreditRelease>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-5 p-0">
              <div class="card d-flex p-0 flex-column">
                <div class="card-header py-1">
                  <p class="m-0 fs-3 fw-bold pl-5">Credits Earned</p>
                </div>
                <div class="card-body p-0">
                  <table class="fs-4 border-left border-top border-right">
                    <thead class="  ">
                      <th class="fw-bold pl-5">Actual Time</th>
                      <th class="fw-bold">Credit Ratio</th>
                      <th class="fw-bold">Conduct Credits</th>
                      <th class="fw-bold">Total</th>
                    </thead>

                    <tbody v-if="creditDayArray?.length > 0">
                      <tr class="border-top" v-for="(daysObj, i) in creditDayArray" :key="i">
                        <td class="pl-5">
                          {{ (daysObj?.daysServed).toLocaleString() }}
                        </td>
                        <td class="">{{ daysObj?.rate }}%</td>
                        <td class="">
                          {{ (daysObj?.creditDays).toLocaleString() }}
                        </td>
                        <td class="">
                          {{ (daysObj?.daysServed + daysObj.creditDays).toLocaleString() }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table class="fs-4 table border-left border-right border-bottom">
                    <tbody class=" ">
                      <tr>
                        <td class="fw-bold pl-5">Actual Time Served</td>
                        <td class=" ">
                          {{
                            vueNumberFormat(crData?.actualDaysTotal || 0, {
                              prefix: "",
                              acceptNegative: false,
                              isInteger: false,
                              decimal: "",
                              precision: 0,
                              thousand: ",",
                            })
                          }}
                          days
                        </td>
                      </tr>
                      <tr>
                        <td class="fw-bold pl-5">Conduct Credit</td>
                        <td class="">
                          {{
                            vueNumberFormat(crData?.conductCredit || 0, {
                              prefix: "",
                              acceptNegative: false,
                              isInteger: false,
                              decimal: "",
                              precision: 0,
                              thousand: ",",
                            })
                          }}
                          days
                        </td>
                      </tr>
                      <tr></tr>
                    </tbody>
                    <tfoot>
                      <tr class="border-bottom">
                        <td class="fw-bold pl-5">Total Credit</td>
                        <td class="">
                          {{
                            vueNumberFormat(crData?.totalCredit || 0, {
                              prefix: "",
                              acceptNegative: false,
                              isInteger: false,
                              decimal: "",
                              precision: 0,
                              thousand: ",",
                            })
                          }}
                          days
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <!-- End of Credits -->
          </div>
        </div>
        <div class="col-12 px-0 pt-3 d-flex" v-if="mode == 'Probation'">
          <NewProbation
            :charges="charges.data"
            :selectedCase="selectedCase"
            :ProbationLimitations="ProbationLimitations"
            :probationFactors="ProbationFactors"
            :caseProbationLimitations="CaseProbationLimitations"
            :caseProbationFactors="CaseProbationFactors"
            @selectCharge="selectCharge"
            @displayModalPopup="displayModalPopup"
            @addChargeFromPopup="postCharge"
            @onCalc="onCalc()"
            @generateProbationReport="generateProbationReport"
          >
          </NewProbation>
        </div>
        <div class="col-12 px-0 d-flex" v-if="mode == 'Case Settings'">
          <CaseSettings
            :charges="charges.data"
            :caseSelected="selectedCase"
            :user_token="user_token"
            :selectedCharge="selectedCharge"
            :organizationSettings="organizationSettings"
            @refreshCharges="mount"
            @onCalc="onCalc"
            @selectCharge="selectCharge"
            @displayModalPopup="displayModalPopup"
            @deleteAllCharges="deleteAllCharges"
            @showUpdateMultiple="popup = 'Edit Multiple Charges'"
            @insertChargeBetweenCounts="insertChargeBetweenCounts"
            @showCountNumberFixer="popup = 'Adjust Count Numbers'"
          />
        </div>
        <div class="col-12 px-0 d-flex" v-if="mode == 'Release Date'">
          <div class="col-12 col-lg-8 p-0 d-flex flex-wrap">
            <div class="col-12 col-lg-6 p-0 border-right pt-3">
              <div class="card p-0 border-left fs-5">
                <!-- Early Parole Consideration (Prop 57) // for later -->

                <p class="section-header fw-bold pl-5">Sentence</p>

                <div class="card-body p-0 overflow-auto">
                  <div class="flex-column d-flex">
                    <span class="fw-bold fs-3 pl-5">Determinate Term</span>
                    <table class="table w-100 fs-5 p-0 border-0 border-bottom mb-5">
                      <tbody class="">
                        <tr class="p-1 border-top">
                          <td class="p-3 pl-5 m-1 pr-4 border-0 w-75">Base Term</td>
                          <td class="text-left p-3 m-1 ml-3 w-50 border-0">
                            <!-- {{vueNumberFormat(exposureDaysCrime, {prefix: '', isInteger: true, decimal: '', precision: 0  })}} days -->
                            <!-- {{ parseDays(true, exposureDaysPrincipal).exp || 0 }} -->
                            {{ displayExposureObject(formattedExposure.basePrincipalTerm) }}
                          </td>
                        </tr>
                        <tr class="p-1">
                          <td class="p-3 pl-5 m-1 pr-4 border-0 w-75">Base Term Enhancements</td>
                          <td class="text-left p-3 m-1 ml-3 w-50 border-0">
                            {{ displayExposureObject(formattedExposure.conductPrincipalTerm) }}
                          </td>
                        </tr>

                        <tr class="p-1" v-if="formattedExposure.subordinateTermBases">
                          <td class="p-3 pl-5 m-1 pr-4 border-0">Subordinate Terms</td>
                          <td class="text-left p-3 m-1 ml-3 border-0">
                            <!-- {{ parseDays(true, exposureDaysSubordinate).exp || 0 }} -->
                            {{ displayExposureObject(formattedExposure.subordinateTermBases) }}
                          </td>
                        </tr>
                        <tr class="p-1" v-if="formattedExposure.subordinateTermEnhancements?.rawDays">
                          <td class="p-3 m-1 pl-5 pr-4 border-0 w-75">Conduct Enhancements</td>
                          <td class="text-left p-3 m-1 ml-3 w-50 border-0">
                            {{ displayExposureObject(formattedExposure.subordinateTermEnhancements) }}
                          </td>
                        </tr>
                        <tr class="p-1" v-if="formattedExposure.sixSevenSixBases?.rawDays">
                          <td class="p-3 pl-5 m-1 pr-4 border-0">Violent Sex Crime/PC 667.6 Term</td>
                          <td class="text-left p-3 m-1 ml-3 border-0">
                            {{ displayExposureObject(formattedExposure.sixSevenSixBases) }}
                          </td>
                        </tr>
                        <tr class="p-1" v-if="formattedExposure.sixSevenSixEnhancements?.rawDays">
                          <td class="p-3 m-1 pl-5 pr-4 border-0 w-75">Viol Sex Crime/PC 667.6 Conduct Enhancements</td>
                          <td class="text-left p-3 m-1 ml-3 w-50 border-0">
                            {{ displayExposureObject(formattedExposure.sixSevenSixEnhancements) }}
                          </td>
                        </tr>
                        <tr class="p-1" v-if="formattedExposure.statusEnhancements?.rawDays">
                          <td class="p-3 pl-5 m-1 pr-4 border-0">Status Enhancements</td>
                          <td class="text-left p-3 m-1 ml-3 border-0">
                            {{ displayExposureObject(formattedExposure.statusEnhancements) }}
                          </td>
                        </tr>
                        <tr class="p-1 m-1" v-if="formattedExposure.totalConductEnhancements?.rawDays">
                          <td class="p-3 pl-5 m-1 pr-4 border-0">Conduct Enhancements</td>
                          <td class="text-left p-3 m-1 ml-3 border-0">
                            {{ displayExposureObject(formattedExposure.totalConductEnhancements) }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot class="fs-5">
                        <tr class="p-1 m-1">
                          <td class="p-3 pl-5 m-1 pr-4">Aggregate Term</td>
                          <td class="text-left p-3 m-1 ml-3" style="border: 0; border-top: 1px solid black">
                            {{ displayExposureObject(formattedExposure.totalDeterminate) }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                    <span class="fw-bold fs-3 mt-5 pl-5" v-if="exposureDaysMisdemeanor">Misdemeanors</span>
                    <table class="table w-100 p-3 fs-5 border-bottom mb-5" v-if="exposureDaysMisdemeanor">
                      <tbody class="border-0">
                        <tr class="p-1 m-1">
                          <td class="p-3 pl-5 fs-5 m-1 pr-4 w-75 border-0">Misdemeanors</td>
                          <td class="text-left p-3 fs-5 m-1 ml-3 w-25 border-0">{{ exposureDaysMisdemeanor }}d</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div
                    class="d-flex flex-column"
                    v-if="formattedExposure.totalIndeterminate?.rawDays || specialIndeterminate"
                  >
                    <span class="fw-bold fs-3 pl-5">Indeterminate Term</span>
                    <table class="table w-100 p-3 border-bottom fs-5 mb-5">
                      <tbody class="border-0 fs-5" v-if="formattedExposure.totalIndeterminate?.rawDays">
                        <tr class="p-1 m-0">
                          <td class="p-3 pl-5 pr-4 w-75 border-0">Indeterminate</td>
                          <td class="text-left p-3 ml-3 w-25 border-0">
                            <span>
                              {{ parseDays(false, formattedExposure.totalIndeterminate?.rawDays).exp || 0 }}
                              - L
                            </span>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot class="border-0 fs-5">
                        <tr class="p-1" v-if="!specialIndeterminate">
                          <td class="p-3 pl-5 pr-4 border-0 w-75">Total Prison Term</td>
                          <td class="text-left p-3 ml-3 w-25 border-0">
                            {{
                              specialIndeterminate
                                ? specialIndeterminate
                                : parseDays(
                                    false,
                                    formattedExposure.totalIndeterminate?.rawDays +
                                      formattedExposure.totalDeterminate?.rawDays
                                  ).exp
                            }}
                            <span v-if="formattedExposure.totalIndeterminate?.rawDays > 0"> - L</span>
                          </td>
                        </tr>
                        <tr class="p-1 fs-5" v-else-if="specialIndeterminate == 'LWOP'">
                          <td class="p-3 pl-5 pr-4 w-75 border-0">Life without Parole</td>
                          <td class="text-left p-3 ml-3 w-25 border-0">
                            {{ specialIndeterminate == "LWOP" ? "YES" : "NO" }}
                          </td>
                        </tr>
                        <tr class="p-1 fs-5" v-else-if="specialIndeterminate == 'DEATH'">
                          <td class="p-3 pr-4 pl-5 w-75 border-0">Death</td>
                          <td class="text-left p-3 ml-3 w-25 border-0">
                            {{ specialIndeterminate == "DEATH" ? "YES" : "NO" }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div class="d-flex flex-column fs-5" v-if="charges?.data?.some(chg => chg.CrimeSeverityId == 3)">
                    <span class="fw-bold fs-3 pl-5">Prop 57 Eligibility</span>
                    <table class="table w-100 p-0 border-0 border-bottom">
                      <tbody class="fs-5">
                        <tr>
                          <td class="p-3 pr-4 pl-5 w-75 border-0">Eligibility</td>
                          <td class="text-left p-3 ml-3 w-25 border-0">
                            <span v-if="charges.data?.findIndex((chg) => isViolent(chg) || isIndeterminate(chg)) == -1"
                              >Eligible</span
                            >
                            <span v-else>Ineligible</span>
                          </td>
                        </tr>
                        <tr
                          v-if="
                            charges.data?.findIndex((chg) => isViolent(chg) || isIndeterminate(chg)) == -1 &&
                            futureReleaseDate
                          "
                        >
                          <td class="p-3 fs-5 pr-4 pl-5 w-75 border-0">Earliest Parole Date</td>
                          <td class="text-left p-3 fs-5 ml-3 w-25 border-0">
                            <!-- {{ dt(futureReleaseDate, "DD-MM-YYYY") }} -->
                            {{
                              dt(releaseStartDate)
                                .add(
                                  convertExposureToDays(formattedExposure.basePrincipalTerm?.rawDays) -
                                    (crData?.totalCredit || 0),
                                  "days"
                                )
                                .format("MM/DD/YYYY")
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-6 p-0 pt-3">
              <div class="card p-0">
                <p class="section-header pl-5 fw-bold">Release Date Estimation</p>
                <div class="card-body p-0">
                  <table class="table border fs-5">
                    <tbody class="">
                      <tr class="">
                        <td class="pl-5 pl-3">Sentence</td>
                        <td class="border-0 ta-r pr-5">
                          {{ totalCalculatedSentence.toLocaleString() }}
                          days
                        </td>
                      </tr>
                      <tr class="">
                        <td class="pl-5 pl-3">Earned Credits</td>
                        <td class="border-left-0 border-right-0 border-bottom-1 ta-r pr-5">
                          -
                          {{
                            vueNumberFormat(crData?.totalCredit || 0, {
                              prefix: "",
                              isInteger: true,
                              decimal: "",
                              precision: 0,
                            })
                          }}
                          days
                        </td>
                      </tr>
                      <tr class="">
                        <td class="pl-5 pl-3">Balance</td>
                        <td class="p-0 m-0 pl-3 border-left-0 ta-r pr-5">
                          {{
                            vueNumberFormat(totalCalculatedSentence - (crData?.totalCredit || 0), {
                              prefix: "",
                              acceptNegative: false,
                              isInteger: false,
                              decimal: "",
                              precision: 0,
                              thousand: ",",
                            })
                          }}
                          days
                        </td>
                      </tr>
                      <tr class="">
                        <td class="pl-5 pl-3">Future Credit %</td>
                        <td class="border-0 ta-r pr-5">
                          <select v-model="futureCredits" @change="onCalc" class="form-control fs-5">
                            <option :value="0">0%</option>
                            <option :value="15">15%</option>
                            <option :value="20">20%</option>
                            <option :value="100 / 3">33%</option>
                            <option :value="50">50%</option>
                            <option :value="60">60%</option>
                            <option :value="200 / 3">67%</option>
                          </select>
                        </td>
                      </tr>
                      <tr class="">
                        <td class="pl-5 border-0 border-top-0 p-0 m-0 pl-0 pr-0">
                          <div class=" ">
                            Max Future Credits
                            <i
                              class="fa fa-info-circle book_auth"
                              @click="
                                displayModalPopup({
                                  header: 'Most Restrictive Applies',
                                  table: {
                                    component: 'CreditsTable',
                                  },
                                })
                              "
                            ></i>
                          </div>
                        </td>
                        <td class="p-3 ta-r pr-5">
                          {{
                            vueNumberFormat(futureCreditValue, {
                              prefix: "",
                              acceptNegative: false,
                              isInteger: false,
                              decimal: "",
                              precision: 0,
                              thousand: ",",
                            })
                          }}
                          days
                        </td>
                      </tr>

                      <tr class="">
                        <td class="pl-5 pl-3">Remaining Balance</td>
                        <td class="p-3 ta-r pr-5">
                          <!-- {{futureCreditBalance}}  -->

                          <span v-if="futureCreditBalance < 0">(</span>
                          {{
                            vueNumberFormat(totalCalculatedSentence - (crData?.totalCredit || 0) - futureCreditValue, {
                              prefix: "",
                              acceptNegative: false,
                              isInteger: false,
                              decimal: "",
                              precision: 0,
                              thousand: ",",
                            })
                          }}
                          <span v-if="futureCreditBalance < 0">)</span>
                          days
                        </td>
                      </tr>

                      <tr class="" rel="releaseDatePickerTR">
                        <td id="releaseDatePickerTD" name="releaseDatePickerTD" ref="releaseDatePickerTD" class="pl-5 p-3">
                          <label for="releaseDatePicker " class="m-0 p-0">Start Date</label>
                        </td>

                        <td class="p-0 m-0 border-0 ta-r pr-5">
                          <input
                            class="mt-0 mb-0 pr-0 form-control fs-5"
                            type="date"
                            ref="releaseDatePicker"
                            name="releaseDatePicker"
                            t
                            Date
                            v-model="releaseStartDate"
                            title="Date notes and more description goes here"
                            id="releaseDatePicker"
                            @change="releaseStartDateChanged"
                            @keyup.esc="releaseStartDateChanged"
                            @blur="releaseStartDateChanged"
                          />
                          <!-- <span v-if="releaseStartDate!=null">{{dt.utc(releaseStartDate).format('MMMM DD, YYYY')}}</span>
                                                          <span v-else>MM/DD/YYYY</span> -->
                        </td>
                      </tr>

                      <tr class="" v-if="calculatedReleaseDate && releaseStartDate">
                        <td class="pl-5 pl-3">Earliest Release Date</td>
                        <td class="p-3 ta-r pr-5">
                          {{
                            dt(releaseStartDate)
                              .add(totalCalculatedSentence - (crData?.totalCredit || 0) - futureCreditValue, "days")
                              .format("MM/DD/YYYY")
                          }}
                        </td>
                      </tr>
                      <tr class="" v-if="calculatedReleaseDate && releaseStartDate && selectedCase.DefendantBirthdate">
                        <td class="pl-5 pl-3">Current Age</td>
                        <td class="p-3 ta-r pr-5">
                          {{ dt(Date.now()).diff(dt(this.selectedCase.DefendantBirthdate), "years") }}y
                          {{
                            dt(Date.now()).diff(dt(this.selectedCase.DefendantBirthdate), "months") % 12 !== 0
                              ? dt(Date.now()).diff(dt(this.selectedCase.DefendantBirthdate), "months") % 12
                              : ""
                          }}{{
                            dt(Date.now()).diff(dt(this.selectedCase.DefendantBirthdate), "months") % 12 !== 0 ? "m" : ""
                          }}
                        </td>
                      </tr>

                      <tr class="" v-if="calculatedReleaseDate && releaseStartDate && selectedCase.DefendantBirthdate">
                        <td class="pl-5 pl-3">
                          Age at
                          {{ totalIndeterminate > 0 ? "Earliest" : "" }} Release
                        </td>
                        <td class="p-3 ta-r pr-5">
                          {{
                            dt(releaseStartDate)
                              .add(totalCalculatedSentence - (crData?.totalCredit || 0) - futureCreditValue, "days")
                              .diff(dt(this.selectedCase.DefendantBirthdate), "years")
                          }}y
                          {{
                            dt(releaseStartDate)
                              .add(totalCalculatedSentence - (crData?.totalCredit || 0) - futureCreditValue, "days")
                              .diff(dt(this.selectedCase.DefendantBirthdate), "months") %
                              12 !==
                            0
                              ? dt(releaseStartDate)
                                  .add(totalCalculatedSentence - (crData?.totalCredit || 0) - futureCreditValue, "days")
                                  .diff(dt(this.selectedCase.DefendantBirthdate), "months") % 12
                              : ""
                          }}
                          {{
                            dt(releaseStartDate)
                              .add(totalCalculatedSentence - (crData?.totalCredit || 0) - futureCreditValue, "days")
                              .diff(dt(this.selectedCase.DefendantBirthdate), "months") %
                              12 !==
                            0
                              ? "m"
                              : ""
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 px-0 pt-3 d-flex" v-if="mode == 'Jury Instructions'">
          <JuryInstructions
            :charges="charges.data"
            :selectedCase="selectedCase"
            :caseJuryInstructions="juryInstructions"
            @displayJuryInstructionsPopup="displayJuryInstructionsPopup"
          >
          </JuryInstructions>
        </div>
        <!-- <div class="col-12 px-0 pl-5 pt-3 d-flex" v-if="mode == 'Reports'">
          <div class="d-flex flex-column card px-0 mob-mb-2" style="min-height: 310px">
            <div class="d-flex card-body mob-col flex-column scrollable">
              <h1 class="section-header fw-bold">Reports</h1>
              <div class="d-flex align-items-center mb-3">
                <button
                  class="btn btn-xl btn-primary mr-3"
                  v-if="!allReportOptionsChecked"
                  @click="
                    toggleAllreportOptions(true);
                    reportOptionsAll = true;
                  "
                >
                  Check All
                </button>
                <button
                  class="btn btn-xl btn-primary-outline"
                  v-if="!allReportOptionsUnchecked"
                  @click="
                    toggleAllreportOptions(false);
                    reportOptionsAll = false;
                  "
                >
                  Uncheck All
                </button>
                
              </div>

              <ul class="p-0 d-flex flex-column flex-wrap col-12">
                <li style="list-style: none" class="d-flex align-items-center mb-3">
                  <input
                    type="checkbox"
                    class="mr-3"
                    id="coverPage"
                    v-model="reportOptions.coverPage"
                  />

                  <label class="fs-5 mt-0 pl-1 clickable mb-0" for="coverPage"
                    >Cover Page</label
                  >
                </li>
                <li style="list-style: none" class="d-flex align-items-center mb-3">
                  <input
                    ref="ExposureCalculationReport"
                    v-model="reportOptions.exposure"
                    class="mr-3"
                    type="checkbox"
                    id="Exposure"
                  />

                  <label class="fs-5 mt-0 pl-1 clickable mb-0" for="Exposure"
                    >Incarceration Summary</label
                  >
                </li>
                <li style="list-style: none" class="d-flex align-items-center mb-3">
                  <input
                    ref="Credits/Release"
                    v-model="reportOptions.releaseDate"
                    class="mr-3"
                    type="checkbox"
                    id="Credits/Release"
                  />

                  <label class="fs-5 mt-0 pl-1 clickable mb-0" for="Credits/Release"
                    >Custody Credits & Release Date</label
                  >
                </li>
                <li style="list-style: none" class="d-flex align-items-center mb-3">
                  <input
                    ref="CaseDetailsReport"
                    v-model="reportOptions.caseDetails"
                    class="mr-3"
                    type="checkbox"
                    id="ReportCaseDetails"
                  />

                  <label class="fs-5 mt-0 pl-1 clickable mb-0" for="ReportCaseDetails"
                    >Collateral Consequences</label
                  >
                </li>

                <li style="list-style: none" class="d-flex align-items-center mb-3">
                  <input
                    ref="probationEligibility"
                    v-model="reportOptions.probationEligibility"
                    class="mr-3"
                    type="checkbox"
                    id="probationEligibility"
                  />

                  <label class="fs-5 mt-0 pl-1 clickable mb-0" for="probationEligibility"
                    >Probation</label
                  >
                </li>
                <li
                  style="list-style: none"
                  class="d-flex align-items-center mb-3"
                  v-if="reportOptions?.probationEligibility"
                >
                  <input
                    ref="probationFactors"
                    v-model="reportOptions.probationFactors"
                    class="mr-3"
                    type="checkbox"
                    id="probationFactors"
                  />

                  <label class="fs-5 mt-0 pl-1 clickable mb-0" for="probationFactors"
                    >Probation Findings Checklist</label
                  >
                </li>
                <li style="list-style: none" class="d-flex align-items-center mb-3">
                  <input
                    ref="CircumstancesReport"
                    v-model="reportOptions.circumstances"
                    class="mr-3"
                    type="checkbox"
                    id="CircumstancesReport"
                  />

                  <label class="fs-5 mt-0 pl-1 clickable mb-0" for="CircumstancesReport"
                    >Factors in Aggravation & Mitigation</label
                  >
                </li>
                <li style="list-style: none" class="d-flex align-items-center mb-3">
                  <input
                    ref="ElementsReport"
                    v-model="reportOptions.elements"
                    class="mr-3"
                    type="checkbox"
                    id="ElementsReport"
                  />

                  <label class="fs-5 mt-0 pl-1 clickable mb-0" for="ElementsReport"
                    >Elements</label
                  >
                </li>
                <li style="list-style: none" class="d-flex align-items-center mb-3">
                  <input
                    ref="ExposureTextCalculationReport"
                    v-model="reportOptions.exposureTextCase"
                    class="mr-3"
                    type="checkbox"
                    id="ExposureText"
                  />

                  <label class="fs-5 mt-0 pl-1 clickable mb-0" for="ExposureText"
                    >Punishment Text</label
                  >
                </li>
                <li style="list-style: none" class="d-flex align-items-center mb-3">
                  <input
                    ref="ElementsReport"
                    v-model="reportOptions.definitionTextCase"
                    class="mr-3"
                    type="checkbox"
                    id="StatueText"
                  />

                  <label class="fs-5 mt-0 pl-1 clickable mb-0" for="StatueText"
                    >Statute Text</label
                  >
                </li>
                <button
                  class="btn btn-primary btn-xl my-3"
                  v-if="!loading"
                  @click="generateReport"
                >
                  Generate Report
                </button>
                <LoadingButton v-else class="my-3" style="height: 36.6px"></LoadingButton>
              </ul>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- <div class="col-12 py-5 my-5"></div>
                    <div class="col-12 py-2 my-2"></div> -->

    <!-- END OF PRIMARY ROW -->

    <!-- MODAL ENDS -->

    <!-- </div>
    </div> -->

    <!-- <Modal v-show="isModalVisible" @close="closeModal">
        
        <template v-slot:header>
                        <div class="fs-6b fw-bold text-dark">
                        {{lawText.caption}}
                        </div>
            
                        <div  v-if="app_attr.isAdmin==1 && lawText.chg !== undefined" class="float-right pr-5">
                                <button class="btn btn-sm btn-primary" @click="editNow(lawText.chg)">Edit</button>
                        </div>
        </template>
            
        <template v-slot:body>
            <blockquote id="blockQ" @show="scroll2top()" style="overflow:auto;max-height:100px; min-height:100%;" class="fs-6b fw-bolder text-dark p-2 shadow-sm border" contenteditable="false" v-html="lawText.body"></blockquote>
        </template>
            
        <template v-slot:footer>
            
        </template>

    </Modal> -->

    <!-- <SC :app_token="app_token" :selectedCase="selectedCase"></SC> -->
  </main>
</template>

<script>
import { ref } from "vue";
import axios from "axios";
// import VueScrollTo from "vue-scrollto";
import moment from "moment";

//import SC from './SC/SClib';

//import SC from './';
import SC from "../../components/utils/sharedComponent.vue";
import { defaultRunStir } from "../../chargeControlHelpers";

import Crimes from "./Crimes.vue";
import LawText from "./LawText.vue";
import CreditRelease from "./ControlPanel/CreditRelease.vue";

import CDHOffense from "./CDHOffense.vue";
// import CDHConsequence from "./CDHConsequence.vue";
import CDHIncarceration from "./CDHIncarceration.vue";
import CDBOffense from "./CDBOffense.vue";
import CDBIncarceration from "./CDBIncarceration.vue";
import Modal from "../../components/utils/Modal.vue";

import LoadingButton from "../../components/utils/LoadingButton.vue";

import EditCase from "./NewCase.vue";
// import Notifications from "./BonusFeatures/Notifications.vue";

// import OneStrikeLawCalculator from "./ControlPanel/OneStrikeLawCalculator.vue";
// import SexSentencing from "./ControlPanel/SexSentencing.vue";
import CaseSettings from "./ControlPanel/CaseSettings.vue";
import DotsonTable from "./DotsonTable.vue";
import CreditsTable from "./CreditsTable.vue";
// import CollateralConsequences from "./ControlPanel/CollateralConsequences.vue";
import CPKSelector from "./ControlPanel/CPKSelector.vue";
import AddCharge from "./ControlPanel/AddCharge.vue";
import JailTime from "./ControlPanel/JailTime.vue";
// import CrimeDetails from "./ControlPanel/CrimeDetails.vue";
import RuleWords from "./ControlPanel/RuleWords.vue";
import PostLoginHeader from "../Authentication/PostLoginHeader.vue";
import { RouterLink } from "vue-router";
import { toRaw } from "vue";
import CDBWorkspace from "./CDBWorkspace.vue";
import JuryInstructions from "./ControlPanel/JuryInstructions.vue";
import NewProbation from "./ControlPanel/NewProbation.vue";
import Circumstances from "./ControlPanel/Circumstances.vue";

import { handleError } from "../../helpers";
// import CaseSettings from "./ControlPanel/CaseSettings.vue";
import { useCaseStore } from "../../stores/CaseStore";
import ManageScenariosModal from "./ControlPanel/ManageScenariosModal.vue";
import UpdateMultipleCharges from "./ControlPanel/UpdateMultipleCharges.vue";
import CountNumberFixer from "./ControlPanel/CountNumberFixer.vue";

const picked = ref(new Date());

export default {
  name: "ComponentDetails",
  components: {
    RouterLink,
    EditCase,
    Crimes,
    LawText,
    Modal,
    CDHOffense,
    CDHIncarceration,
    Circumstances,
    CDBOffense,
    CDBWorkspace,
    CDBIncarceration,
    SC,
    CreditRelease,
    LoadingButton,
    // OneStrikeLawCalculator,
    // SexSentencing,
    CaseSettings,
    // Scenarios,
    DotsonTable,
    CreditsTable,
    // CollateralConsequences,
    CPKSelector,
    AddCharge,
    JailTime,
    // CrimeDetails,
    RuleWords,
    PostLoginHeader,
    JuryInstructions,
    NewProbation,
    ManageScenariosModal,
    UpdateMultipleCharges,
    CountNumberFixer,
  },

  props: [
    "key",
    // "app_attr",
    "launchCrimesLookup",
  ],
  watch: {
    selectedScenario: function (newVal, oldVal) {
      // console.log('selectedScenario:::', newVal, oldVal);
      if (oldVal != null) {
        window.location.href = `/Cases/${newVal}?showReportModal=1`;
        this.reportOptions.includeScenarioTitle = true;
        // console.log("selectedScenario changed, redirecting to new case with report modal");
        // this.showGenerateReportModal = true;
      }
    },
    // numberOfStrikes: function (newVal, oldVal) {
    //   if (newVal != oldVal) {
    //     this.fixStrikeNumber()
    //     this.selectChargeNumber(newVal)
    //   }
    // }
  },

  data() {
    return {
      caseStore: useCaseStore(),
      exposureDaysCrime: 0,
      exposureDaysConductEnhancemant: 0,
      exposureDaysPrincipal: 0,
      exposureDaysBaseTerm: 0,
      exposureDaysSubordinate: 0,
      exposureDaysStatusEnhancements: 0,
      exposureDaysMisdemeanor: 0,
      exposureDaysAggregateTerm: 0,
      maxConcurrentTerm: 0,
      totalIndeterminate: 0,
      specialIndeterminate: null,
      LawTextObject: {},
      // currentCase: null,
      // selectedCase: null,
      charges: { data: [] },
      new_charges: [],
      chargesOrig: [],
      dt: moment,
      showCrimesTable: false,
      toggleView: "toggleIncarceration",
      toggleViewText: "Incarceration",
      currentCount: 0,
      showingExposure: true,
      crimeCategories: null,
      crData: {
        actualDaysTotal: 0,
        crData: null,
        conductCredit: 0,
        totalCredit: 0,
        ratioChecked: 0,
      }, // credit release data

      lawText: {
        caption: "",
        title: "",
        body: "",
        footer: "",
        chg: "",
        refTableInfo: {},
        chgIndex: 0,
        obj: {},
      },
      isModalVisible: false,
      selectedTerm: 0,
      highestTerm: 0,
      pressCnt: 0,
      reanimate: true,
      exposure: [],
      total_misd: 0,
      total_det: 0,
      total_ind: 0,
      total_spc: 0,

      noActivity: true,
      prevNumChargesCount: 0, // number of charges before adding a new one

      chargesProbation: [],

      window: {
        width: 0,
        height: 0,
        gridheight: 0,
      },

      panel1Form: {
        openOn: "right",
      },

      width: 0,
      height: 0,
      top: 0,
      left: 0,

      // btnRatio: 50,
      releaseStartDate: null,
      afCreditPercentage: 0,
      releaseDatePickerShow: false,
      futureCreditValue: 0,
      futureCreditBalance: 0,
      futureReleaseDate: null,
      enhMistmatchCrimeData: null,
      enhMismatch: false,
      loading: false,
      editCaseInfoPanelVisible: false,
      reportOptions: {
        exposure: false,
        collateralConsequencesCase: false,
        elements: false,
        releaseDate: false,
        caseDetails: false,
        exposureTextCase: false,
        definitionTextCase: false,
        pc1170hTextCase: false,
        immigrationConsequencesTextCase: false,
        collateralConsequencesTextCase: false,
        immigrationConsequencesCase: false,
        coverPage: false,
        includeScenarioTitle: false,
        probationEligibility: false,
        probationEligibilityText: false,
        probationFactors: false,
        circumstances: false,
        crimeDetails: false,
        excludeNonConvictedCrimes: false,

        moduleReportNames: {
          coverTitleName: null,
          scenarioCoverTitleName: null,
          incarcerationSummaryName: null,
          crimeDetailsName: null,
          collateralConsequencesName: null,
          probationName: null,
          aggAndMitName: null,
          elementsName: null,
          punishmentTextName: null,
          statuteTextName: null,
        },
      },
      reportSettings: {
        clientMode: true,
        hideReportLegend: false,
        largerFontSize: false,
      },
      reportOptionsAll: false,
      coverTitle: "",
      notifications: [],
      showNotifications: false,
      principalTies: [],
      caseFactors: {
        mitigating: {},
        aggravating: {},
        misc: {},
      },
      showSexModule: false,
      showTextModal: false,
      modalObject: {},
      selectedTab: "Credits",
      controllerKey: 0,
      selectedCharge: null,
      futureCredits: 50,
      popup: null,
      reportLanguage: "en",
      victims: [],
      prop57Eligbility: false,
      prop57UseStrict: false,
      addChargeObject: null,
      // probationEligibility: 0,
      showControls: false,
      formattedExposure: {},
      calculatedReleaseDate: null,
      totalCalculatedSentence: null,
      ProbationLimitations: [],
      ProbationFactors: [],
      CaseProbationLimitations: [],
      CaseProbationFactors: [],
      creditDayArray: [],
      ruleWordsIds: [],
      foundRuleWords: [],
      detailedView: false,
      showCDFooter: true,
      showDeleteChargePopup: false,
      showInstructionModal: false,
      instructionObject: null,
      caseCircumstances: [],
      mode: "Charges",
      showMenuOptions: true,
      showGenerateReportModal: false,

      selectedScenario: null,
      openScenarioManagerModal: false,
      showCreateScenarioModal: false,
      copyScenarioObject: {
        charges: true,
        chargeSettings: true,
        probationLimitations: true,
        probationFactors: true,
        custodyCredits: true,
        releaseDate: true,

        ProbationLimitations: [],
        ProbationFactors: [],
        CaseProbationLimitations: [],
        CaseProbationFactors: [],
        currentScenarioId: null,
      },
      showManageScenariosModal: false,
      mainCase: null,
      showIncarcerationSummaryInput: false,
      insertChargeCountNumber: null,
      organizationSettings: {},
      juryInstructions: [],
      // numberOfStrikes: "0",
      hideReportLegendInfoModal: false,
      clientModeInfoModal: false,
    };
  },

  // async beforeMount() {
  //   window.addEventListener("resize", this.handleResize);
  //   this.handleResize();
  // },

  // destroyed() {
  //   window.removeEventListener("resize", this.handleResize);
  // },

  computed: {
    selectedCase() {
      return this.caseStore.selectedCase;
    },

    isMainCase() {
      const paramId = Number(this.$route.params.caseId);
      if (this.caseStore.selectedCase?.ParentCaseId == null) {
        return true;
      }
      return false;
    },

    // selectedScenarioName() {
    //   if (this.scenarios?.length > 0) {
    //     const selected = this.scenarios.find(scenario => scenario.Id === this.selectedScenario);
    //     return selected ? selected.ScenarioName : null;
    //   }
    //   return null;
    // },

    scenarioName() {
      if (this.caseStore.isSelectedCaseParentCase == true) {
        return null;
      }
      return this.caseStore.selectedCase.ScenarioName;
    },

    probationEligibility() {
      let probationEligibilityObject = {
        Eligible: true,
        Unusual: false,
        SpecialA: false,
        SpecialB: false,
        InelFromCharges: false,
        InelFromLimitations: false,
        InelFromStrikes: false,
      };
      this.CaseProbationLimitations.forEach((cpl) => {
        let pl = this.ProbationLimitations.find((pl) => pl.Id == cpl.ProbationLimitationId);
        if (pl?.Eligibility == 1) {
          probationEligibilityObject.Eligible = false;
          probationEligibilityObject.InelFromLimitations = true;
        } else if (pl?.Eligibility == 2 || pl?.Eligibility == 3) {
          probationEligibilityObject.Unusual = true;
        } else if (pl?.Eligibility == 3 || pl?.Eligibility == 4) {
          probationEligibilityObject.SpecialA = true;
        } else if (pl?.Eligibility == 5) {
          probationEligibilityObject.SpecialB = true;
        }
      });
      let felony = false;
      let strikes = false;
      this.charges?.data.forEach((chg) => {
        if (chg?.CrimeSeverityId == 3 && chg?.ChargeStatus == 0) {
          felony = true;
        }
        if (chg.NumberOfStrikes != "0" && chg.NumberOfStrikes != null && chg.ChargeStatus == 0) {
          strikes = true;
        }
      });
      this.charges.data
        ?.filter((chg) => {
          return (
            chg?.ProbationLimitationId !== null &&
            chg?.ProbationLimitation !== 0 &&
            chg?.ChargeStatus == 0 &&
            (chg?.CrimeState == "Completed" || chg?.Attributes?.severityTypePicked == "Completed")
          );
        })
        .forEach((chg) => {
          if (chg?.ProbationLimitation == 1) {
            probationEligibilityObject.Eligible = false;
            probationEligibilityObject.InelFromCharges = true;
          }
          if (chg?.ProbationLimitation == 2 || chg?.ProbationLimitation == 3) {
            probationEligibilityObject.Unusual = true;
          }
          if (chg?.ProbationLimitation == 3 || chg?.ProbationLimitation == 4 || chg?.ProbationLimitation == 5) {
            probationEligibilityObject.SpecialA = true;
          }
          if (chg?.ProbationLimitation == 5) {
            probationEligibilityObject.SpecialB = true;
          }
        });
      if (felony && strikes) {
        probationEligibilityObject.InelFromStrikes = true;
        probationEligibilityObject.Eligible = false;
      }
      return probationEligibilityObject;
    },

    allReportOptionsChecked() {
      const unused = [
        "collateralConsequencesCase",
        "pc1170hTextCase",
        "immigrationConsequencesTextCase",
        "collateralConsequencesTextCase",
        "immigrationConsequencesCase",
        "probationEligibilityText",
      ];

      if (!this.reportOptions) return false;

      return Object.keys(this.reportOptions).every((key) => unused.includes(key) || this.reportOptions[key]);
    },
  },

  methods: {
    // turnOffReportOptions() {
    //   //sets report options to false
    //   Object.keys(this.reportOptions).forEach((key) => {
    //     this.reportOptions[key] = false;
    //   });
    // },

    changeScenarioName(event) {
      const selectedCaseId = parseInt(event.target.value, 10);
      if (selectedCaseId === this.caseStore.selectedCaseParentCaseId) {
        // console.log("Selected parent case", selectedCaseId);
        this.reportOptions.includeScenarioTitle = false;
      };
      this.mount()
    },

    selectCase(caseId) {
      this.caseStore.selectedCaseId = caseId;

      if (this.$route.params.caseId != caseId) {
        this.$router.push(`/Cases/${caseId}`);
      }

      this.mount();
    },

    clearURLQueryParams() {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: {},
      });
    },

    // toggleAddCrimePopup(newCharge, oldCharge) {
    //   this.addChargeObject = {
    //     chargeToAdd: newCharge,
    //     // chargeToEnhance: oldCharge,
    //     // countNumber: oldCharge.CountNumber,
    //     helpText:
    //       "If this charge is selected to be in furtherance of a criminal street gang, you must add the following enhancement to the selected charge.",
    //     caseId: this.selectedCase.Id,
    //   };
    //   this.popup = "Add Enhancement";
    // },
    reload() {
      // console.log("RELOAD");
      this.mount();
    },

    async selectCharge(index) {
      // console.log(this.selectedCharge);
      this.selectedCharge = null;
      // await this.$nextTick();
      this.selectedCharge = index;
      // console.log(this.charges.data[this.selectedCharge]);
    },
    closeEditCase(val) {
      this.editCaseInfoPanelVisible = false;
      // console.log("val:", val);

      this.selectedCase.DefendantFirstName = val.DefendantFirstName;
      this.selectedCase.DefendantLastName = val.DefendantLastName;
      this.selectedCase.DefendantMiddleName = val.DefendantMiddleName;
      this.selectedCase.DefendantBirthdate = val.DefendantBirthdate;
      this.selectedCase.CaseNumber = val.CaseNumber;
    },

    editCaseInfo() {
      this.editCaseInfoPanelVisible = true;
      // console.log("case info button pressed:", this.editCaseInfoPanelVisible);
    },

    releaseDateCalc() {
      this.futureReleaseDate = this.dt(this.releaseStartDate).add(
        this.convertExposureToDays(this.exposureDaysTotalDeterminate + this.totalIndeterminate) -
          (this.crData.totalCredit +
            (this.convertExposureToDays(this.exposureDaysTotalDeterminate + this.totalIndeterminate) -
              this.expectedSentence)),
        "days"
      );
    },

    releaseStartDateChanged() {
      this.releaseDatePickerShow = false;
      // console.log('releaseStartDateChange()::>>>', this.releaseStartDate, this.futureCreditBalance);
      this.releaseDateCalc();
      this.updateCaseData();
      this.onCalc(true);
    },

    updateCaseData() {
      // console.log("bad case, no.");
      let token = this.app_token;
      let Id = this.selectedCase.Id;
      let caseAttribObj = this.selectedCase?.caseAttributes || {};
      caseAttribObj.crData = this.crData;
      caseAttribObj.crDatabtnRatio = this.futureCredits;
      caseAttribObj.crDatareleaseStartDate = this.releaseStartDate;
      caseAttribObj.crDatafutureCreditsRatio = this.futureCredits || this.afCreditPercentage;
      let body = {
        Id: Id,
        caseAttributes: caseAttribObj,
      };

      axios
        .put(process.env.VUE_APP_ENDPOINT + `/api/cases/${Id}`, body, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          // console.log(`statusCode:`, res);
          // console.log(res.status);
          if (res.status == 200 || res.status == 201) {
            // console.log("case updated.");
          }
        })
        .catch((error) => {
          console.error("case save error::::", error);
        });
    },

    jailTimePopup(emitObj) {
      // console.log(emitObj);
      this.selectedCharge = this.charges.data?.findIndex((chg) => chg.Id == emitObj.charge?.Id);
      this.popup = "Jail Time";
    },

    displayJuryInstructionsPopup(instructionObj) {
      this.instructionObject = instructionObj;
      this.showInstructionModal = true;
    },

    toggleRuleWordsPopup(emitObj) {
      this.selectedCharge = this.charges.data?.findIndex((chg) => chg.Id == emitObj.charge?.Id);
      this.popup = "Sentencing Rules";
    },

    // Generic Credits Calculator
    creditsCalc(ratio, actualDaysTotal) {
      let this_btnRatio = ratio;
      let this_crData_actualDaysTotal = actualDaysTotal;
      let conductCredit = Math.ceil(actualDaysTotal * (1 / (1 - this_btnRatio / 100) - 1)) - (actualDaysTotal % 2);
      if (ratio == 15) {
        // this_btnRatio = 12.90322580645;
        conductCredit = Math.floor(actualDaysTotal * 0.15);
      }
      if (actualDaysTotal < 4 || this_btnRatio == 0) {
        conductCredit = 0;
      }
      return { conductCredit: conductCredit, actualDaysTotal: actualDaysTotal };
    },

    futureCreditsCalc(ratio, actualDaysTotal) {
      this.futureCreditBalance = (actualDaysTotal - (actualDaysTotal % 2)) * (ratio / 100);
      this.releaseDateCalc();

      return this.futureCreditBalance;
    },

    async displayModalPopup(modalObject, queryObject) {
      // console.log(modalObject);
      if (modalObject) {
        this.modalObject = modalObject;
        this.showTextModal = true;
      } else {
        this.showTextModal = true;
        this.modalObject = {
          header: "Test Post",
          body: "pleaseIgnore",
        };
      }
    },

    updateCreditsCalc() {
      let data = this.creditsCalc(this.futureCredits, this.crData.actualDaysTotal);

      this.crData.conductCredit = data.conductCredit;
      this.crData.actualDaysTotal = data.actualDaysTotal;

      this.crData.totalCredit = this.crData.conductCredit + this.crData.actualDaysTotal;

      // this.afCreditsCalc();

      this.updateCaseData();
    },

    updateCredits(data) {
      // -12.9032258064516
      let timeServed = 0;
      let conductCreditDays = 0;
      let ratioTableArray = [0, 0, 0, 0, 0, 0];
      let ratioArr = [0, 0.15, 0.2, 1 / 3, 0.5, 2 / 3];
      if (data) {
        data?.crData?.forEach((dr) => {
          if (dr.dateIn?.length > 1) {
            timeServed += dr.actualDays;
            switch (dr.creditRatio) {
              case 2 / 3:
                ratioTableArray[5] += dr.actualDays;
                break;
              case 0.5:
                ratioTableArray[4] += dr.actualDays;
                break;
              case 1 / 3:
                ratioTableArray[3] += dr.actualDays;
                break;
              case 0.2:
                ratioTableArray[2] += dr.actualDays;
                break;
              case 0.15:
                ratioTableArray[1] += dr.actualDays;
                break;
              case 0:
                ratioTableArray[0] += dr.actualDays;
                break;
            }
            // if (dr.actualDays % 2 == 1 && timeServed % 2 == 0) {
            //   conductCreditDays += this.creditsCalc(dr.creditRatio * 100, dr.actualDays + 1)
            //     ?.conductCredit;
            // } else {
            //   conductCreditDays += this.creditsCalc(dr.creditRatio * 100, dr.actualDays)
            //     ?.conductCredit;
            // }
          }
        });
        for (let i = 1; i < 6; i++) {
          conductCreditDays += this.creditsCalc(ratioArr[i] * 100, ratioTableArray[i])?.conductCredit;
        }
        this.creditDayArray = ratioTableArray
          .map((days, i) => {
            if (days > 0) {
              return {
                daysServed: days,
                rate: Math.floor(ratioArr[i] * 100),
                creditDays: this.creditsCalc(ratioArr[i] * 100, days)?.conductCredit,
              };
            }
          })
          .filter((val) => val);
        this.crData.crData = data.crData;
        this.crData.actualDaysTotal = timeServed;
        this.crData.conductCredit = conductCreditDays;
        this.crData.totalCredit = timeServed + conductCreditDays;
        this.afCreditsCalc();

        this.updateCaseData();
      }
    },

    parseDays(truefalse, total_ind) {
      return SC.parseDays(truefalse, total_ind);
    },

    displayLawText(obj) {
      this.LawTextObject = obj;

      this.$refs.LawTextRef.displayLawText(obj);

      /* await SC.sleep(500).then(display => {

                let token = this.app_token;
                let chg = obj.chg;
                let url = process.env.VUE_APP_ENDPOINT + "/api/db/view/" + obj.params.view + '/' + obj.params.column;

            // console.log(obj, 'URL::', url);

                this.lawText.caption = "";
                if (obj.params.title !== undefined)
                this.lawText.caption = obj.params.title;

                this.lawText.body = 'Fetching data from the server.  Please wait.';
                this.editor.commands.setContent(this.lawText.body);
                this.lawText.chg = chg;
                this.lawText.obj = obj;

                axios
                    .get(url, {
                        headers: { Authorization: `Bearer ` + token }
                    })
                    .then( view => {
                    // console.log('view-->:::', view);

                        let v = view.data[0];

                        Object.defineProperty(obj, 'updateinfo', {
                            value: {},
                            writable: true
                        });

                        Object.defineProperty(obj.updateinfo, 'table', {
                            value: '',
                            writable: true
                        });

                        Object.defineProperty(obj.updateinfo, 'field', {
                            value: '',
                            writable: true
                        });

                        Object.defineProperty(obj.updateinfo, 'id', {
                            value: 0,
                            writable: true
                        });

                        Object.defineProperty(obj.updateinfo, 'value', {
                            value: 0,
                            writable: true
                        });

                        if (v.info.refForeignKey == '') {
                            url = process.env.VUE_APP_ENDPOINT + "/api/" + v.table.toLowerCase() + '/' + chg.CrimeId;
                            obj.updateinfo.table = v.table;
                            obj.updateinfo.field = v.field;
                            obj.updateinfo.id = chg.CrimeId;
                        }
                        else {
                            url = process.env.VUE_APP_ENDPOINT + "/api/" + v.table.toLowerCase() + '/' + chg[v.info.refForeignKey];
                            obj.updateinfo.table = v.table;
                            obj.updateinfo.field = v.field;
                            obj.updateinfo.id = chg[v.info.refForeignKey];
                        }

                        if (v.info.refTable != '' && v.info.refAlias == '')
                        {
                            //url = process.env.VUE_APP_ENDPOINT + "/api/" + v.table.toLowerCase() + '/' + chg[v.info.key];
                            url = process.env.VUE_APP_ENDPOINT + "/api/" + v.info.refTable.toLowerCase() + '/' + chg[v.info.key];

                            axios
                            .get(url, {
                                headers: { Authorization: `Bearer ` + token }
                            })
                            .then( record => {
                            // console.log("record--> :::", record);

                                if (record.error === undefined) {

                                    url = process.env.VUE_APP_ENDPOINT + "/api/" + v.table.toLowerCase() + '/' + record.data[v.info.alias + 'Id'];

                                    obj.updateinfo.table = v.table;
                                    obj.updateinfo.field = v.field;
                                    obj.updateinfo.id = record.data[v.info.alias + 'Id'];

                                // console.log("v.info.alias + 'Id'" , v.info.alias + 'Id', '=', record.data[v.info.alias + 'Id']);

                                    axios
                                    .get(url, {
                                        headers: { Authorization: `Bearer ` + token }
                                    }).then( finalrecord => {
                                    // console.log('finalrecord:::-->', finalrecord)

                                    // console.log("finalrecord->field:::", finalrecord.data, v.field );
                                        this.lawText.body = finalrecord.data[v.field];
                                        this.editor.commands.setContent(this.lawText.body);

                                        obj.updateinfo.value = this.editor.getHTML();
                                    }).catch(err => {

                                        this.lawText.body = 'Error:Unable to fetch this data from the server.';

                                    })
                                }

                            }).catch(err => {

                                this.lawText.body = 'Unable to fetch this data from the server.';

                            })

                        } else {

                            axios.get(url, {
                                headers: { Authorization: `Bearer ` + token }
                            }).then( record => {


                            // console.log("record->field:::", record.data, v.field );
                                this.lawText.body = record.data[v.field];
                                this.editor.commands.setContent(this.lawText.body);
                                this.lawText.chg = chg;

                                obj.updateinfo.value = this.editor.getHTML();

                            })

                        }

                    // console.log('record URL::', url);
                    })
                    .catch(error => {
                        console.error('error::', error)
                    })

                // this.lawText.caption = chg.codeDefinitionCode + ' ' + chg.SectionNumber;
                // this.lawText.title = 'Info';
                // this.lawText.body = description;
                // // this.lawText.footer = name;
                // this.lawText.chg = chg;

                //

                // // this.setModalHeight();
                // // this.isModalVisible = true;

                // this.lawText.refTableInfo = refTableInfo;
                // console.log('refTableInfo:::', refTableInfo);

                this.showInfoSection = true;

            }) */
    },

    executeSuperStrike(e) {
      // console.log("superstrikeevent", e);
      // console.log(e.target.checked == true);
      if (e.target.checked == true) {
        this.charges.data?.forEach((element) => {
          element.NumberOfStrikes = "2+!";
          SC.postChargeField(this.app_token, element.Id, "NumberOfStrikes", "2+!");
        });
        this.onCalc();
        let countFelonies = 0;
      } else {
        this.executeStrike2();
      }
      // console.log('e.target.value:::', e.target.checked);

      // console.log('pre-init:', this.countFelonies);
      // this.charges.data.forEach(element => {
      //     if (element.CrimeSeverityName == 'Felony') {
      //         countFelonies++;
      //     }
      // });

      // this.charges.data.forEach((element, index) => {

      //     let eO = this.chargesOrig.data[index];

      //     element.LowerTermLength = eO.LowerTermLength;
      //     element.LowerTermUnits = eO.LowerTermUnits;
      //     element.MiddleTermLength = eO.MiddleTermLength;
      //     element.MiddleTermUnits = eO.MiddleTermUnits;
      //     element.UpperTermLength = eO.UpperTermLength;
      //     element.UpperTermUnits = eO.UpperTermUnits;

      //     element.isStrike = eO.isStrike;
      //     element.NumberOfStrikes = eO.NumberOfStrikes;

      // });

      // if (e.target.checked) {

      //     this.charges.data.forEach((element, index) => {

      //         if (element.CrimeSeverityName == 'Felony') {
      //             if (countFelonies > 1) {

      //                 // console.log('oldterm2:', element.LowerTermLength, element.MiddleTermLength, element.UpperTermLength, element.NumberOfStrikes, element.isStrike);

      //                 if (!element.IsLWOP && !element.IsDeath) {

      //                     if (
      //                         (element.NumberOfStrikes == '1' || element.NumberOfStrikes == '0') &&
      //                         element.isStrike == 'Yes' &&
      //                         element.CrimeType != 'Conduct enhancement'
      //                     ) {
      //                         element.LowerTermLength = 25;
      //                         element.LowerTermUnits = 365;
      //                         element.MiddleTermLength = 25;
      //                         element.MiddleTermUnits = 365;
      //                         element.UpperTermLength = 25;
      //                         element.UpperTermUnits = 365;
      //                     }

      //                     if (
      //                         (element.NumberOfStrikes == '1' || element.NumberOfStrikes == '0') &&
      //                         element.isStrike == 'Yes'
      //                     ) {
      //                         element.NumberOfStrikes = '2+';
      //                     }

      //                     if (
      //                         (element.NumberOfStrikes == '0') &&
      //                         element.isStrike == 'No'
      //                     ) {
      //                         element.NumberOfStrikes = '1';

      //                         element.LowerTermLength = this.chargesOrig.data[index].LowerTermLength * 2;
      //                         element.LowerTermUnits = this.chargesOrig.data[index].LowerTermUnits;
      //                         element.MiddleTermLength = this.chargesOrig.data[index].MiddleTermLength * 2;
      //                         element.MiddleTermUnits = this.chargesOrig.data[index].MiddleTermUnits;
      //                         element.UpperTermLength = this.chargesOrig.data[index].UpperTermLength * 2;
      //                         element.UpperTermUnits = this.chargesOrig.data[index].UpperTermUnits;
      //                     }
      //                 }
      //                 // console.log('newterm2:', element.LowerTermLength, element.MiddleTermLength, element.UpperTermLength, element.NumberOfStrikes, element.isStrike);

      //             }
      //         }
      //     });
      // }
    },

    executeStrike0() {
      let countFelonies = 0;

      // console.log('pre-init:', this.countFelonies);

      this.charges.data.forEach((element) => {
        if (element.CrimeSeverityName == "Felony") {
          countFelonies++;
        }
      });

      this.charges.data.forEach((element, index) => {
        //if (element.CrimeSeverityName == 'Felony')
        {
          //if (countFelonies > 1)
          {
            // console.log('oldterm0:', element.LowerTermLength, element.MiddleTermLength, element.UpperTermLength);

            // if (
            // 	(element.NumberOfStrikes == '1' || element.NumberOfStrikes == '2+')  &&
            // 	element.CrimeType != 'Conduct enhancement'
            // )
            // {
            //     element.LowerTermLength = this.chargesOrig.data[index].LowerTermLength;
            //     element.MiddleTermLength = this.chargesOrig.data[index].MiddleTermLength;
            //     element.UpperTermLength = this.chargesOrig.data[index].UpperTermLength;

            // }
            SC.postChargeField(this.app_token, element.Id, "NumberOfStrikes", "0");
            element.NumberOfStrikes = "0";

            // console.log('newterm0:', element.LowerTermLength, element.MiddleTermLength, element.UpperTermLength);
          }
        }
      });
      this.onCalc();
      return this.countFelonies;
    },

    executeStrike1() {
      let countFelonies = 0;

      // console.log('pre-init:', this.countFelonies);

      this.charges.data.forEach((element) => {
        if (element.CrimeSeverityName == "Felony") {
          countFelonies++;
        }
      });

      this.charges.data.forEach((element, index) => {
        // if (element.CrimeSeverityName == 'Felony') {
        //     if (countFelonies > 1) {

        // console.log('oldtermq:', element.LowerTermLength, element.MiddleTermLength, element.UpperTermLength);

        // if (!element.IsLWOP && !element.IsDeath) {

        //     if (
        //         (element.NumberOfStrikes == '0' || element.NumberOfStrikes == '2+') &&
        //         element.CrimeType != 'Conduct enhancement'
        //     ) {
        //         element.LowerTermLength = this.chargesOrig.data[index].LowerTermLength * 2;
        //         element.MiddleTermLength = this.chargesOrig.data[index].MiddleTermLength * 2;
        //         element.UpperTermLength = this.chargesOrig.data[index].UpperTermLength * 2;

        //     }
        SC.postChargeField(this.app_token, element.Id, "NumberOfStrikes", "1");
        element.NumberOfStrikes = "1";
        // }

        // console.log('newtermq:', element.LowerTermLength + ':' + this.chargesOrig.data[index].LowerTermLength, element.MiddleTermLength, element.UpperTermLength);

        //     }
        // }
      });
      this.onCalc();
      return this.countFelonies;
    },

    executeStrike2() {
      // console.log("strike 2");
      let countFelonies = 0;

      // console.log('pre-init:', this.countFelonies);

      this.charges.data.forEach((element) => {
        if (element.CrimeSeverityName == "Felony") {
          countFelonies++;
        }
      });

      this.charges.data.forEach((element, index) => {
        element.NumberOfStrikes = "2+";
        SC.postChargeField(this.app_token, element.Id, "NumberOfStrikes", "2+");
        // if (element.CrimeSeverityName == 'Felony') {
        //     if (countFelonies > 1) {

        //         // console.log('oldterm2:', element.LowerTermLength, element.MiddleTermLength, element.UpperTermLength, element.NumberOfStrikes, element.isStrike);

        //         if (!element.IsLWOP && !element.IsDeath) {

        //             if (
        //                 (element.NumberOfStrikes == '1' || element.NumberOfStrikes == '0') &&
        //                 element.isStrike == 'Yes' &&
        //                 element.CrimeType != 'Conduct enhancement'
        //             ) {
        //                 element.LowerTermLength = 25;
        //                 element.LowerTermUnits = 365;
        //                 element.MiddleTermLength = 25;
        //                 element.MiddleTermUnits = 365;
        //                 element.UpperTermLength = 25;
        //                 element.UpperTermUnits = 365;

        //             }

        //             if (
        //                 (element.NumberOfStrikes == '1' || element.NumberOfStrikes == '0') &&
        //                 element.isStrike == 'Yes'
        //             ) {
        //                 element.NumberOfStrikes = '2+';
        //             }

        //             if (
        //                 (element.NumberOfStrikes == '0') &&
        //                 element.isStrike == 'No'
        //             ) {
        //                 element.NumberOfStrikes = '1';

        //                 element.LowerTermLength = this.chargesOrig.data[index].LowerTermLength * 2;
        //                 element.LowerTermUnits = this.chargesOrig.data[index].LowerTermUnits;
        //                 element.MiddleTermLength = this.chargesOrig.data[index].MiddleTermLength * 2;
        //                 element.MiddleTermUnits = this.chargesOrig.data[index].MiddleTermUnits;
        //                 element.UpperTermLength = this.chargesOrig.data[index].UpperTermLength * 2;
        //                 element.UpperTermUnits = this.chargesOrig.data[index].UpperTermUnits;
        //             }
        //         }
        //         // console.log('newterm2:', element.LowerTermLength, element.MiddleTermLength, element.UpperTermLength, element.NumberOfStrikes, element.isStrike);

        //     }
        // }
      });
      this.onCalc();
      return this.countFelonies;
    },

    isViolent(chg) {
      return SC.isViolent(chg);
    },

    async generateReport() {
      this.loading = true;
      const token = localStorage.getItem("user_token");

      let bodyObj = {
        pageTitle: "Case Summary",
        modules: [],
        reportSettings: [],
      };
      let chgs = this.charges.data;
      if (this.reportOptions.excludeNonConvictedCrimes) {
        chgs = chgs.filter((chg) => {
          return chg.ChargeStatus == 0;
        });
      }

      bodyObj.case = this.selectedCase;

      //Client Settings
      if (this.reportSettings.clientMode) {
        // console.log(chgs)
        bodyObj.clientMode = true;
        bodyObj.reportSettings.push("clientMode");
      }
      if (this.reportSettings.hideReportLegend) {
        bodyObj.hideReportLegend = true;
        bodyObj.reportSettings.push("hideReportLegend");
      }
      if (this.reportSettings.largerFontSize) {
        bodyObj.largerFontSize = true;
        bodyObj.reportSettings.push("largerFontSize");
      }

      if (this.reportOptions.includeScenarioTitle) {
        bodyObj.modules.push("includeScenarioTitle");
        // bodyObj.coverPageObject = { coverTitle: this.selectedCase?.ScenarioName };
        // bodyObj.defendantInfoObject = { case: this.selectedCase };
      } 
      if (this.reportOptions.coverPage) {
        bodyObj.modules.push("coverTitle");
        bodyObj.coverPageObject = { coverTitle: this.coverTitle };
        bodyObj.defendantInfoObject = { case: this.selectedCase };
      }
      // Incarceration Summary
      if (this.reportOptions.exposure) {
        let exposureObject = this.formattedExposure;

        bodyObj.modules.push("exposure");
        bodyObj.exposureObject = exposureObject;
        bodyObj.exposureObject.specialIndeterminate = this.specialIndeterminate;
        bodyObj.exposureObject.charges = chgs;
      }
      // Estimated Release Date
      if (this.reportOptions.releaseDate) {
        let expoTotal = this.exposure.total_det + this.exposure.total_ind + this.exposure.total_misd;
        let exposureObj = SC.parseDays(false, expoTotal);
        let exposureObject = this.formattedExposure;
        let sentenceDate = this.dt(this.releaseStartDate || Date.now())
          // .add(1, "days")
          .format("YYYY-MM-DD");
        let releaseDate = this.calculatedReleaseDate;
        let rdObj = {
          exposure: {
            years: Math.floor(this.totalCalculatedSentence / 365),
            months: Math.floor((this.totalCalculatedSentence % 365) / 30),
            days: Math.floor((this.totalCalculatedSentence % 365) % 30),
          },
          creditRate: parseInt(this.futureCredits),
          creditEarned: this.crData?.totalCredit || 0,
          sentenceDate: sentenceDate,
          daysLeft: this.totalCalculatedSentence - this.crData.totalCredit - this.futureCreditValue,
          releaseDate: this.dt(this.releaseStartDate)
            .add(this.totalCalculatedSentence - (this.crData?.totalCredit || 0) - this.futureCreditValue, "days")
            .format("MM/DD/YYYY"),
        };
        bodyObj.releaseDateObject = rdObj;
        bodyObj.expoObject = exposureObject;
        bodyObj.modules.push("releaseDate");

        if (this.crData?.crData?.length > 0) {
          let drArr = [];
          this.crData?.crData?.forEach((crObj) => {
            let rowObj = {
              inDate: crObj.dateIn,
              outDate: crObj.dateOut,
              days: crObj.actualDays,
              creditRate: this.futureCredits,
            };
            if (rowObj.days !== 0) {
              drArr.push(rowObj);
            }
          });
          let creditReportObject = {
            dateRanges: drArr,
          };
          bodyObj.creditReportObject = creditReportObject;
          bodyObj.timeServedArray = this.creditDayArray;
          // bodyObj.modules.push("custodyCredits");
        }
        // let crObj = {
        //   dateRanges: [],
        //   datesArray: [],
        //   ratesArray: [],
        //   creditsArray: [],
        //   totalDays: 0,
        //   conductCreditDays: 0,
        // };
        // if (this.crData.crData?.length > 0) {
        //   this.crData.crData?.forEach((dr) => {
        //     // console.log(dr);
        //   });
        // }
      }
      // if (this.reportOptions.crimeDetails) {
      //   bodyObj.modules.push("crimeDetails");
      //   bodyObj.charges = chgs;
      // }

      // Charges Collateral Consequences Dot Report
      if (this.reportOptions.caseDetails) {
        const defObj = {
          charges: chgs,
          case: this.selectedCase,
          exposure: {
            daysCrime: this.exposureDaysCrime,
            daysConductEnhancement: this.exposureDaysConductEnhancement,
            daysPrincipal: this.exposureDaysPrincipal,
            daysBaseTerm: this.exposureDaysBaseTerm,
            daysSubordinate: this.exposureDaysSubordinate,
          },
        };
        bodyObj.modules.push("defendantInfo");
        bodyObj.defendantInfoObject = defObj;
      }

      // if (this.reportOptions.collateralConsequencesCase) {
      //   let ccCaseArray = [];
      //   chgs?.forEach((chg) => {
      //     if (chg?.ccArray) {
      //       let rowObj = {
      //         CrimeId: chg.CrimeId,
      //         header: `${chg.codeDefinitionCode} ${chg.SectionNumber}: ${chg.Name}`,
      //       };
      //       let bodyString = `\n`;
      //       chg?.ccArray?.forEach((cc) => {
      //         // console.log(cc);
      //         bodyString += cc?.Name;
      //         bodyString += `\n`;
      //         if (this.reportOptions.collateralConsequencesTextCase) {
      //           bodyString += `${cc?.LawTextYes} \n ${cc?.LawTextYes} \n`;
      //         }
      //       });
      //       rowObj.body = bodyString;
      //       ccCaseArray.push(rowObj);
      //     }
      //   });
      //   bodyObj.collateralConsequences = ccCaseArray;
      //   bodyObj.modules.push("collateralConsequencesCase");
      // }

      // Probation
      if (this.reportOptions.probationEligibility) {
        const caseProbationLimitations = this.CaseProbationLimitations;

        const selectedProbationLimitations = [];
        caseProbationLimitations.forEach((cpl) => {
          const probLimit = this.ProbationLimitations.find((pl) => pl.Id == cpl.ProbationLimitationId);
          const foundPledIndex = this.charges.data.findIndex(
            (chg) => chg.ProbationLimitationId == cpl.ProbationLimitationId
          );
          if (cpl.IsTrue || cpl.IsTrue == 1) {
            probLimit.true = cpl.IsTrue;
            probLimit.pled = probLimit.Pleadable && foundPledIndex !== -1;
            selectedProbationLimitations.push(probLimit);
          }
        });
        bodyObj.ProbationFindings = selectedProbationLimitations;
        bodyObj.caseObj = this.selectedCase;
        bodyObj.probationEligibility = this.probationEligibility;
        bodyObj.charges = chgs;
        bodyObj.modules.push("probationEligibility");

        if (this.reportOptions.probationFactors) {
          const probationFactors = this.ProbationFactors;
          probationFactors.forEach((pf) => {
            pf.checked = this.CaseProbationFactors.findIndex((cpf) => cpf.ProbationFactorId == pf.Id) !== -1;
          });
          const foundCrimeCriteria = probationFactors.filter((pf) => pf.Category == "Crime");
          const foundDefendantCriteria = probationFactors.filter((pf) => pf.Category == "Defendant");
          const foundUnusualCriteria = probationFactors.filter((pf) => pf.Category == "Unusual");
          const foundSexACriteria = probationFactors.filter((pf) => pf.Category == "Special A");
          const foundSexBCriteria = probationFactors.filter((pf) => pf.Category == "Special B");
          let criteriaObj = {
            crime: foundCrimeCriteria,
            defendant: foundDefendantCriteria,
            unusual: foundUnusualCriteria,
            sexA: foundSexACriteria,
            sexB: foundSexBCriteria,
          };
          // console.log("CRITERIA OBJ", criteriaObj);
          bodyObj.probationCriteriaObj = criteriaObj;
        }
      }

      // Aggravating, Mitigating, Concurrent/Consecutive Imposition
      if (this.reportOptions.circumstances) {
        const circumstances = await axios
          .get(process.env.VUE_APP_ENDPOINT + "/api/circumstances", {
            headers: { Authorization: `Bearer ` + this.app_token },
          })
          .then((data) => {
            return data.data.map((c) => {
              if (this.caseCircumstances.findIndex((cc) => cc.CircumstancesId == c.Id) !== -1) {
                c.checked = true;
              } else {
                c.checked = false;
              }
              return c;
            });
          })
          .catch((err) => {
            console.error(err);
          });
        bodyObj.circumstances = circumstances;
        bodyObj.circumstances.reportName = this.reportOptions.circumstancesName;
        bodyObj.modules.push("circumstances");
      }

      // Elements
      if (this.reportOptions.elements) {
        let elementsArray = [];
        this.charges?.data?.forEach((chg) => {
          let rowObj = {
            CrimeId: chg?.CrimeId,
            header: `${chg.SectionNumber}: ${chg.Name}`,
          };
          let bodyString = `\n${chg?.Elements}`;
          rowObj.body = bodyString;
          elementsArray.push(rowObj);
        });
        bodyObj.elements = elementsArray;
        bodyObj.modules.push("elementsCase");
      }

      // Punishment Text
      if (this.reportOptions.exposureTextCase) {
        let exposureTextArray = [];
        this.charges?.data?.forEach((chg) => {
          let rowObj = {
            CrimeId: chg?.CrimeId,
            header: `${chg.SectionNumber}: ${chg.Name}`,
          };
          let bodyString = `\n${chg?.PunishmentText}`;
          rowObj.body = bodyString;
          exposureTextArray.push(rowObj);
        });
        bodyObj.exposureText = exposureTextArray;
        bodyObj.modules.push("exposureTextCase");
      }

      // Statute Text
      if (this.reportOptions.definitionTextCase) {
        let definitionTextArray = [];
        this.charges?.data?.forEach((chg) => {
          let rowObj = {
            CrimeId: chg?.CrimeId,
            header: `${chg.SectionNumber}: ${chg.Name}`,
          };
          let bodyString = `\n${chg?.DefinitionText}`;
          rowObj.body = bodyString;
          definitionTextArray.push(rowObj);
        });
        bodyObj.definitionText = definitionTextArray;
        bodyObj.modules.push("definitionTextCase");
      }

      // PC 1170H Eligibility
      if (this.reportOptions.pc1170hTextCase) {
        let pc1170hTextArray = [];
        this.charges?.data?.forEach((chg) => {
          let rowObj = {
            CrimeId: chg?.CrimeId,
            header: `${chg.SectionNumber}: ${chg.Name}`,
          };
          let bodyString = `\n${chg?.PC1170h_CC_LawText}`;
          rowObj.body = bodyString;
          pc1170hTextArray.push(rowObj);
        });
        bodyObj.pc1170hText = pc1170hTextArray;
        bodyObj.modules.push("pc1170hTextCase");
      }

      //Immigration Consequences (Commented out of reports)
      // if (this.reportOptions.immigrationConsequencesCase) {
      //   let immigrationConsequencesTextArray = [];
      //   this.charges?.data?.forEach((chg) => {
      //     let rowObj = {
      //       CrimeId: chg?.CrimeId,
      //       header: `${chg.codeDefinitionCode} ${chg.SectionNumber}: ${chg.Name}`,
      //     };
      //     let bodyString = `\n`;

      //     bodyString += `Aggravated Felony Offense: ${SC.ynm(chg.IsAggravatedFelony)}\n`;
      //     if (this.reportOptions.immigrationConsequencesTextCase) {
      //       bodyString += `${chg.AggravatedFelonyText}\n`;
      //     }
      //     bodyString += `Firearm Offense: ${SC.ynm(chg.IsFirearm)}\n`;
      //     if (this.reportOptions.immigrationConsequencesTextCase) {
      //       bodyString += `${chg.FirearmText}\n`;
      //     }
      //     bodyString += `Drug Offense: ${SC.ynm(chg.IsDrug)}\n`;
      //     if (this.reportOptions.immigrationConsequencesTextCase) {
      //       bodyString += `${chg.DrugText}\n`;
      //     }
      //     bodyString += `Domestic Violence Offense: ${SC.ynm(chg.IsDomesticViolence)}\n`;
      //     if (this.reportOptions.immigrationConsequencesTextCase) {
      //       bodyString += `${chg.DomesticViolenceText}\n`;
      //     }
      //     bodyString += `Involves Moral Turpitude: ${SC.ynm(chg.IsMoralTurpitude)}\n`;
      //     if (this.reportOptions.immigrationConsequencesTextCase) {
      //       bodyString += `${chg.MoralTurpitudeText}\n`;
      //     }

      //     rowObj.body = bodyString;
      //     immigrationConsequencesTextArray.push(rowObj);
      //   });
      //   bodyObj.immigrationConsequencesText = immigrationConsequencesTextArray;
      //   bodyObj.modules.push("immigrationConsequencesTextCase");
      // }
      // if (this.reportOptions.collateralConsequencesTextCase) {

      // }
      // if (this.reportLanguage !== "en") {
      //   bodyObj.language = this.reportLanguage;
      // }

      const pdf = await fetch(process.env.VUE_APP_ENDPOINT + `/api/reports/createpdf`, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyObj),
      })
        .then((r) => r.json())
        .then(async (result) => {
          // console.log(result);
          let path = result?.fileName;
          await fetch(process.env.VUE_APP_ENDPOINT + `/api/reports/download/${path}`, {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/pdf",
            },
          })
            .then((r) => r.blob())
            .then(async (result) => {
              let blob = await new Blob([result], { type: "application/pdf" });
              let link = window.URL.createObjectURL(blob);
              // console.log(link);
              window.open(link, "_blank");
            });
        })
        .catch((e) => {
          console.error(e);
          this.loading = false;
          //sets report options to false
          // Object.keys(this.reportOptions).forEach((key) => {
          //   this.reportOptions[key] = false;
          // });
        });
      this.clearURLQueryParams();
      this.loading = false;
      // Object.keys(this.reportOptions).forEach((key) => {
      //   this.reportOptions[key] = false;
      // });
    },
    async deleteAllCharges() {
      const token = localStorage.getItem("user_token");
      this.charges.data.forEach((chg) => {
        this.onTrashCharge(chg.Id, chg, true);
      });
      this.charges.data = [];
      this.mode = "Charges";
      this.showCrimesTable = true;
    },

    async onCalc() {
      let notifications = [];
      SC.sortCharges(this.charges.data, this.app_token);
      notifications = notifications.concat(SC.enhancementSweep(this.charges.data));
      SC.setExposureObject(this.charges.data);
      SC.enhancementSweep(this.charges.data);

      notifications = notifications.concat(SC.gangSentencing(this.charges.data));
      SC.applySubstitutions(this.charges.data);
      let sexCrimesNotifs = SC.sexCrimesCheck(this.charges.data, true);
      this.showSexModule = sexCrimesNotifs;

      // this.probationEligibility = SC.probationEligibility(
      //   this.charges.data,
      //   this.selectedCase
      // );
      SC.violentOffenders(this.charges.data, this.selectedCase);

      notifications = notifications.concat(SC.threeStrikeFormula(this.charges.data));
      this.principalTies = SC.getPrincipalCharge(this.charges.data);
      SC.handleConcurrency(this.charges.data);
      // Auto-mirror changeable enhancements to their base charge's concurrency (only when
      // the base actually changes), then persist any that flipped.
      SC.syncEnhancementConcurrency(this.charges.data).forEach((c) => {
        SC.postChargeFieldValue(c.Id, "Concurrency", c.Concurrency, localStorage.getItem("user_token"), c.CaseId);
      });
      SC.enhancementSweep(this.charges.data);
      let sentencingObject = SC.sentencing(this.charges.data, this.releaseStartDate, this.selectedCase);
      let finalExposureObject = sentencingObject.finalExposureObject;
      notifications = notifications.concat(sentencingObject.notifications);
      this.exposureDaysMisdemeanor = finalExposureObject.misdemeanor;
      this.formattedExposure = sentencingObject.displayExpoObject;
      this.maxConcurrentTerm = finalExposureObject.maxConcurrentTerm;
      this.expectedSentence = finalExposureObject.totalExpectedSentence;
      this.totalCalculatedSentence = sentencingObject.fullSentence;
      this.calculatedReleaseDate = sentencingObject.releaseDate;
      notifications = notifications.filter((notif) => notif?.length > 0);
      this.specialIndeterminate = null;
      if (finalExposureObject.death) {
        this.specialIndeterminate = "DEATH";
      } else if (finalExposureObject.lwop) {
        this.specialIndeterminate = "LWOP";
      }
      this.notifications = notifications;

      this.charges.data?.forEach((chg) => {
        if (chg.newExposureObject?.ruleWordsIds?.length > 0) {
          chg.newExposureObject?.ruleWordsIds.forEach((rw) => {
            let foundIndex = this.ruleWordsIds.findIndex((rwId) => rwId == rw);
            if (foundIndex == -1) {
              this.ruleWordsIds.push(rw);
            }
          });
        }
      });
      // this.fixStrikeNumber()
      this.getRuleWords();
      this.updateCredits(this.selectedCase?.caseAttributes?.crData);

      // this.reanimate = animate;
      // console.log("CHARGES AFTER CALC", this.charges.data);
    },

    displayExposureObject(obj) {
      let string = "";
      if (!obj) {
        return string;
      }
      if (obj.years > 0) {
        string += `${obj.years}y `;
      }
      if (obj.months > 0) {
        string += `${obj.months}m `;
      }
      if (obj.days > 0) {
        string += `${obj.days}d`;
      }
      return string;
    },

    executeStrikeFromCase() {
      this.$nextTick(() => {
        let strikeString = "0";
        if (this.selectedCase.NumberOfStrikes == 1) {
          strikeString = "1";
        } else if (this.selectedCase.NumberOfStrikes == 2) {
          strikeString = "2+";
        } else if (this.selectedCase.NumberOfStrikes == 3) {
          strikeString = "2+!";
        }
        this.selectNumberOfStrikes(strikeString);
      });
      axios
        .put(
          process.env.VUE_APP_ENDPOINT + "/api/cases/" + this.selectedCase.Id,
          {
            NumberOfStrikes: this.selectedCase.NumberOfStrikes,
            Id: this.selectedCase.Id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("user_token"),
            },
          }
        )
        .catch(handleError);
    },
    selectNumberOfStrikes(strikeNumber) {
      this.charges.data.forEach((chg, index) => {
        if (chg.NumberOfStrikes !== strikeNumber) {
          chg.NumberOfStrikes = strikeNumber;
          SC.postChargeField(this.app_token, chg.Id, "NumberOfStrikes", chg.NumberOfStrikes);
        }
      });
      this.onCalc();
    },

    async onAddCharge() {
      // await this.getMaxCount().then((t) => {
      this.insertChargeCountNumber = null;
      this.showCrimesTable = true;
      // });

      // result for selection is in addChargesFromCrimeTable
    },

    async getRuleWords() {
      // console.log("GETS RULE WORDS", this.ruleWordsIds);
      const token = this.user_token || localStorage.getItem("user_token");
      if (this.ruleWordsIds?.length > 0) {
        const ruleWords = await axios
          .post(
            process.env.VUE_APP_ENDPOINT + `/api/rulewords/getManyById`,
            {
              ruleWordIds: this.ruleWordsIds,
            },
            {
              headers: { Authorization: `Bearer ` + token },
            }
          )
          .then((results) => {
            this.foundRuleWords = results?.data;
            this.charges.data?.forEach((charge) => {
              if (charge?.newExposureObject?.ruleWordsIds?.length > 0) {
                charge?.newExposureObject?.ruleWordsIds?.forEach((crw) => {
                  const foundRW = this.foundRuleWords.find((rw) => rw.Id == crw);
                  charge.newExposureObject.populatedRuleWords.push(foundRW);
                });
              }
            });
            // console.log(this.charges.data)
          })
          .catch(handleError);
      }

      // If enhanced TST, gets the RuleWord text for that and puts it in the Crime's TST Text
      this.charges?.data?.forEach(async (charge) => {
        if (charge?.EnhancedThirdStrikeTrigger != charge.IsThirdStrikeTrigger) {
          charge.ThirdStrikeTriggerText = await SC.getRuleWordText(35);
        }
      })
    },

    addChargesFromCrimeTable(crimedata, remount, insertChargeCountNumber) {
      if (crimedata.crimeId !== undefined) {
        if (crimedata.currentCount == null || isNaN(crimedata.currentCount)) {
          crimedata.currentCount = 1;
        }

        const isCountNumberOccupied = this.charges.data.some(
          (charge) => charge.CountNumber == crimedata.currentCount && charge.CrimeTypeId == 5
        );
        if (isCountNumberOccupied && insertChargeCountNumber !== null) {
          this.charges.data
            .filter((chg) => chg.CountNumber >= insertChargeCountNumber)
            .forEach((chgToIncrement) => {
              chgToIncrement.CountNumber++;

              SC.postChargeField(this.app_token, chgToIncrement.Id, "CountNumber", chgToIncrement.CountNumber);
            });
        }
        this.postCharge(crimedata, null, remount);
      }
      if (remount) {
        this.mount();
      }

      // console.log(showCrimesTable)
    },

    showModal() {
      this.isModalVisible = true;
    },

    closeModal() {
      this.isModalVisible = false;
    },

    generateProbationReport() {
      this.reportOptions.probationEligibility = true;
      this.reportOptions.probationFactors = true;
      //hacky way to make circumstances report not show up
      this.reportOptions.circumstances = false;
      this.generateReport();
    },
    generateCircumstancesReport() {
      this.reportOptions.circumstances = true;
      //hacky way to make probation eligibility report not show up
      this.reportOptions.probationEligibility = false;
      this.reportOptions.probationFactors = false;
      this.generateReport();
    },

    async postCharge(crimedata, defaultChargeStatus, remount) {
      let token = this.app_token;
      if (isNaN(crimedata.currentCount)) crimedata.currentCount = 1;
      let ChargedPer = crimedata?.ChargedPer;
      ChargedPer = ChargedPer == undefined ? null : ChargedPer;
      let chargeStatus = 0;
      if (defaultChargeStatus) {
        chargeStatus = defaultChargeStatus;
      }
      let twoSuperStrikes =
        this.charges.data.findIndex((chg) => chg.NumberOfStrikes == "2+!") !== -1 || this.selectedCase?.NumberOfStrikes == 3;
      let twoStrikes =
        this.charges.data.findIndex((chg) => chg.NumberOfStrikes == "2+") !== -1 || this.selectedCase?.NumberOfStrikes == 2;
      let oneStrike =
        this.charges.data.findIndex((chg) => chg.NumberOfStrikes == "1") !== -1 || this.selectedCase?.NumberOfStrikes == 1;
      let NumberOfStrikes = "0";
      if (twoSuperStrikes) {
        NumberOfStrikes = "2+";
      } else if (twoStrikes) {
        NumberOfStrikes = "2+";
      } else if (oneStrike) {
        NumberOfStrikes = "1";
      }
      let postdata = {
        ChargedPer: ChargedPer,
        CrimeId: crimedata.crimeId,
        CaseId: this.selectedCase.Id,
        CountNumber: crimedata.currentCount,
        ChargeType: 0,
        ChargeStatus: chargeStatus,
        SelectedTerm: 3,
        ProbationJailTimeDays: 0,
        NumberOfStrikes: NumberOfStrikes,
        CrimeState: crimedata.CrimeState,
        // Only completed crimes default to the 667.6 scheme; Attempt/Conspiracy default to
        // PC 1170.1(a). The scheme can still be toggled on the charge afterward.
        RunSTIRCalculation: defaultRunStir(crimedata.CrimeState),
        IsPrincipal: false,
        Created: moment().format('YYYY-MM-DD HH:mm:ss'),
      };
      if (crimedata?.OffenseDate !== undefined) {
        postdata.Date = crimedata?.OffenseDate;
      }
      if (crimedata?.DateRangeEnd !== undefined) {
        postdata.DateRangeEnd = crimedata?.DateRangeEnd;
      }
      let occasionNumber = 0;
      let highestOccNumberInChgs = 0;
      if (this.charges.data?.length > 0 && this.charges.data[0]?.CrimeId !== 0) {
        this.charges.data.forEach((chg) => {
          if (
            Date.parse(chg.Date) == Date.parse(postdata.Date) &&
            (Date.parse(chg.DateRangeEnd) == Date.parse(postdata.DateRangeEnd) ||
              (isNaN(Date.parse(chg.DateRangeEnd)) && isNaN(Date.parse(postdata.DateRangeEnd))))
          ) {
            // console.log("FINDS MATCHING DATE");
            occasionNumber = chg.Occasion;
          } else if (highestOccNumberInChgs < chg.Occasion) {
            highestOccNumberInChgs = chg.Occasion;
          }
        });
      }
      if (occasionNumber == 0) {
        // console.log("FINDS NO MATCHING DATE");
        occasionNumber = highestOccNumberInChgs + 1;
      }
      postdata.Occasion = occasionNumber;
      this.currentCount = postdata?.CountNumber;
      await axios
        .post(process.env.VUE_APP_ENDPOINT + "/api/charges", postdata, {
          headers: { Authorization: `Bearer ` + token },
        })
        .then((charges) => {
          //this.preRefresh();
          //this.refreshCharges(false);
          if (remount) {
            this.mount();
          }
        })
        .catch((error) => {
          console.error("what was the error:", error);
        });
    },

    toggleShowDelete(charge) {
      this.showDeleteChargePopup = true;
      // console.log(this.$refs)
      this.$nextTick(() => {
        // console.log(this.$refs)
        this.$refs.deleteButton.focus();
      });
      // this.$refs.deleteButton.focus()
    },

    async onTrashCharge(chgId, chg, skipEnhancements) {
      let token = this.app_token;
      // console.log("addressurl:::", process.env.VUE_APP_ENDPOINT + "/api/charges");
      // console.log("DELETED CHARGE", chg);
      let matchingCountNumberChargeIds = [];
      if (chg?.CrimeTypeId == 5 && !skipEnhancements) {
        this.charges.data?.forEach((enh) => {
          if (enh?.CountNumber == chg.CountNumber && enh?.CrimeTypeId !== 5) {
            matchingCountNumberChargeIds.push(enh?.Id);
          }
        });
      }
      const deletedCharges = await axios
        .delete(process.env.VUE_APP_ENDPOINT + "/api/charges/" + chgId, {
          headers: { Authorization: `Bearer ` + token },
        })
        .then((charges1) => {
          // console.log('before delete:', this.charges.data.length);
          if (matchingCountNumberChargeIds?.length > 0) {
            matchingCountNumberChargeIds?.forEach((enh) => {
              axios
                .delete(process.env.VUE_APP_ENDPOINT + "/api/charges/" + enh, {
                  headers: { Authorization: `Bearer ` + token },
                })
                .catch(handleError);
            });
          }
          this.selectedCharge = null;

          return true;
        })
        .catch(handleError);

      this.selectedCharge = null;
      this.charges.data = this.charges.data.filter(
        (chg) => chg.Id !== chgId && !matchingCountNumberChargeIds.includes(chg.Id)
      );
      this.showDeleteChargePopup = false;
      this.onCalc(true);
      // // console.log(matchingCountNumberChargeIds);
      // let msg = "Are you sure you want to delete this charge?";

      // if (matchingCountNumberChargeIds?.length > 0) {
      //   msg += "\nDoing so will delete all attached enhancements";
      // }
      // this.$confirm.require({
      //   message: msg,
      //   header: "Confirmation",
      //   icon: "pi pi-exclamation-triangle",
      //   accept: () => {
      //     this.removeChargeRecord(this.charges.data, chgId);
      //     if (matchingCountNumberChargeIds?.length > 0) {
      //       matchingCountNumberChargeIds.forEach((enh) =>
      //         this.removeChargeRecord(this.charges.data, enh)
      //       );
      //     }

      //   },
      //   reject: () => {
      //     //callback to execute when user rejects the action
      //   },
      // });
    },

    insertChargeBetweenCounts(countNumberToInsertAt) {
      this.popup = null;
      this.mode = "Charges";
      this.insertChargeCountNumber = countNumberToInsertAt;
      this.showCrimesTable = true;
    },

    displayCreditsData() {
      let caseAttrib = this.selectedCase?.caseAttributes;
      // console.log("displayCreditsData() caseAttrib >>>", caseAttrib);

      try {
        // this.btnRatio =  this.futureCredits;
        if (caseAttrib?.crData) {
          this.crData = caseAttrib.crData;
        }

        this.afCreditPercentage = caseAttrib.futureCreditsRatio;
        this.releaseStartDate = caseAttrib.releaseStartDate;
        this.releaseDateCalc();

        // console.log('displayCreditsData() this.crData >>>', this.crData);
        // console.log('displayCreditsData() this.btnRatio >>>', this.btnRatio);

        // console.log('displayCreditsData() this.releaseStartDate >>>', this.releaseStartDate);
        // console.log('displayCreditsData() this.futureReleaseDate >>>', this.futureReleaseDate);

        // console.log('displayCreditsData() this.afCreditPercentage >>>', this.afCreditPercentage);
        // console.log('displayCreditsData() this.this.exposure.total_det >>>', this.exposure.total_det);
        // console.log('displayCreditsData() this.crData.totalCredit >>>', this.crData.totalCredit);
      } catch (e) {
        // console.log("ERROR:::ERROR:::ERROR:::", e);
      }
    },

    afCreditsCalc() {
      // console.log(
      //   this.futureCredits,
      //   this.totalCalculatedSentence,
      //   this.crData.totalCredit
      // );
      this.futureCreditValue = this.futureCreditsCalc(
        this.futureCredits,
        this.totalCalculatedSentence - this.crData.totalCredit
      );
      // console.log(this.futureCreditValue);
      // this.updateCaseData();
    },

    afCreditsClicked(value) {
      this.afCreditPercentage = value;
      this.afCreditsCalc();
    },

    selectPrincipal(PrincipalChargeId) {
      this.charges.data.forEach((charge) => {
        if (charge.Id != PrincipalChargeId) {
          charge.IsPrincipal = false;
          SC.postChargeField(this.app_token, charge.Id, "IsPrincipal", charge.IsPrincipal);
        }
      });
      this.onCalc();
    },

    async loadProbationData() {
      this.ProbationLimitations = await axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/probationLimitations", {
          headers: { Authorization: `Bearer ` + this.app_token },
        })
        .then((data) => {
          return data.data
            .filter((pl) => pl.LegacyStatuteText != "*CATEGORIES*" && pl.Category != "FACTOR" && pl.EndDate == null)
            .sort((a, b) => a.SortOrder - b.SortOrder);
        })
        .catch((error) => {
          console.error(error);
        });
      // console.log(this.ProbationLimitations);
      this.ProbationFactors = await axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/probationFactors", {
          headers: { Authorization: `Bearer ` + this.app_token },
        })
        .then((data) => {
          return data.data ?? [];
        })
        .catch((error) => {
          console.error(error);
          return [];
        });
      this.CaseProbationLimitations = await axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/caseProbationLimitationStatus/" + this.selectedCase.Id, {
          headers: { Authorization: `Bearer ` + this.app_token },
        })
        .then((data) => {
          return data.data ?? [];
        })
        .catch((error) => {
          console.error(error);
        });
      this.CaseProbationFactors = await axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/caseProbationFactors/byCase/" + this.selectedCase.Id, {
          headers: { Authorization: `Bearer ` + this.app_token },
        })
        .then((data) => {
          return data.data ?? [];
        })
        .catch((error) => {
          console.error(error);
        });
      this.charges.data.forEach((chg) => {
        if (chg.ProbationLimitationId !== null && this.ProbationLimitations.length > 0) {
          let probLimit = this.ProbationLimitations.findIndex((pl) => pl.Id == chg.ProbationLimitationId);
          if (probLimit !== -1) {
            chg.ProbationLimitationLawText = this.ProbationLimitations[probLimit].LawText;
          }
        }
      });
      return {
        ProbationLimitations: this.ProbationLimitations,
        ProbationFactors: this.ProbationFactors,
        CaseProbationLimitations: this.CaseProbationLimitations,
        CaseProbationFactors: this.CaseProbationFactors,
      };
    },
    async loadcaseCircumstances() {
      const caseCircumstances = await axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/caseCircumstances/byCase/" + this.selectedCase.Id, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        })
        .then((res) => res.data)
        .catch((e) => console.log(e));
      return caseCircumstances;
    },

    async mount() {
      // console.log("STARTS MOUNT TIMER");
      if (this.selectedCase !== undefined) this.popup = null;
      // console.log('::selectedCase::', this.selectedCase);
      // console.time()
      this.displayCreditsData();

      this.noActivity = false;
      this.prevNumChargesCount = this.charges.length;
      if (this.selectedCase?.caseAttributes === null) {
        this.selectedCase.caseAttributes = {};
      } else if (typeof this.selectedCase?.caseAttributes == "string") {
        this.selectedCase.caseAttributes = JSON.parse(this.selectedCase?.caseAttributes);
      }
      this.releaseStartDate = moment(this.selectedCase?.caseAttributes?.releaseStartDate || Date.now()).format("YYYY-MM-DD");
      var nodata = true;
      SC.getCharges(this.selectedCase.Id, this.app_token)
        .then(async (ptr) => {
          // await SC.addEMGsToCharges(ptr, this.app_token);
          // console.log(ptr);
          if (ptr.data.length == 0) {
            this.charges = { data: [] };
            if (this.showCrimesTable == false) {
              this.onAddCharge();
            }
          } else {
            nodata = false;
            this.charges.data = ptr?.data;
          }
          this.charges.data = ptr?.data;
          // let earliestDate = new Date();
          // this.charges.data?.forEach((chg) => {
          //   if (earliestDate > new Date(chg.Date)) {
          //     earliestDate = new Date(chg.Date);
          //   }
          // });

          // this.selectedCase.IsGang = this.selectedCase.IsGang;
          // this.selectedCase.IsSex = false;
          // this.charges.data.forEach((chg) => {

          //   if (
          //     (chg.IsOneStrikeStrikeTrigger > 0 ||
          //       chg.IsTwoStrikeStrikeTrigger > 0 ||
          //       chg.CrimeCategoryId == 28 ||
          //       chg.CrimeCategoryId == 26) &&
          //     chg.ChargeStatus == 0
          //   ) {
          //     this.selectedCase.IsSex = true;
          //   }
          //   chg.newExposureObject = null;
          // });
          // SC.populateChargesInfo(this.charges, this.app_token);
        })
        .then(async (a) => {
          this.noActivity = true;
          this.onCalc(true);
          await this.fetchOrganizationSettings();
          await this.loadProbationData();
          this.caseCircumstances = await this.loadcaseCircumstances();
          // this.loadJuryInstructions();
          // if (this.charges.data?.length > 0) {
          //   this.selectCharge(this.charges.data[0]);
          // }
          // console.log("END TIMERS");
        });
    },

    // async loadJuryInstructions() {
    //   const juryInstructions = await axios
    //     .get(process.env.VUE_APP_ENDPOINT + "/api/juryInstructions/byCase/" + this.selectedCase?.Id, {
    //       headers: { Authorization: `Bearer ` + localStorage.getItem("user_token") },
    //     })
    //     .then((data) => {
    //       const instructions = data?.data?.instructions;
    //       const subsections = data?.data?.subsections;
    //       this.juryInstructions = instructions.map((instruction) => {
    //         instruction.subsections = subsections.filter((subsection) => {
    //           return subsection.JuryInstructionId == instruction.Id;
    //         });
    //         instruction.include = true;
    //         return instruction;
    //       });
    //     });
    // },

    async fetchOrganizationSettings() {
      const user_atr = JSON.parse(localStorage.getItem("user_attr"));
      if (user_atr?.Subscriber?.SubscriptionType !== 3) {
        return;
      }
      const response = await axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/org/fetchOrganizationSettings", {
          headers: {
            Authorization: `Bearer ` + localStorage.getItem("user_token"),
          },
        })
        .catch(handleError);
      this.organizationSettings = response.data?.organizationSettings;
    },

    convertExposureToDays(expo) {
      // console.log("EXPO DAYS", expo);
      let days = 0;
      if (expo % 360 == 0) {
        days += Math.floor((expo / 360) * 365.25);
      } else {
        let years = expo - (expo % 360);
        let months = expo % 360;
        days += Math.floor((expo / 360) * 365.25) + months;
      }
      // console.log(days);
      return days;
    },

    isIndeterminate(chg) {
      return SC.isIndeterminate(chg);
    },
    async toggleAllreportOptions(val) {
      if (val) {
        const reportOptions = {
          // includeScenarioTitle: true,
          exposure: true,
          collateralConsequencesCase: false,
          elements: true,
          releaseDate: true,
          caseDetails: true,
          exposureTextCase: true,
          definitionTextCase: true,
          pc1170hTextCase: false,
          immigrationConsequencesTextCase: false,
          collateralConsequencesTextCase: false,
          immigrationConsequencesCase: false,
          coverPage: true,
          circumstances: true,
          probationEligibility: true,
          probationFactors: true,
          probationEligibilityText: false,
          // crimeDetails: true,
        };
        this.reportOptions = reportOptions;
      } else {
        const reportOptions = {
          includeScenarioTitle: false,
          exposure: false,
          collateralConsequencesCase: false,
          elements: false,
          releaseDate: false,
          caseDetails: false,
          exposureTextCase: false,
          definitionTextCase: false,
          pc1170hTextCase: false,
          immigrationConsequencesTextCase: false,
          collateralConsequencesTextCase: false,
          immigrationConsequencesCase: false,
          coverPage: false,
          circumstances: false,
          probationEligibility: false,
          probationFactors: false,
          probationEligibilityText: false,
          // crimeDetails: false,
        };
        this.reportOptions = reportOptions;
      }
    },
  },

  async mounted() {
    this.loading = true;
    const token = localStorage.getItem("user_token");
    this.app_token = token;
    this.caseStore = useCaseStore();
    if (this.caseStore.cases.length == 0) {
      await this.caseStore.loadCases(true);
    }

    if (!this.caseStore.selectedCaseId) {
      // console.log('NO CASE')
      const routeId = parseInt(this.$route.params?.caseId);
      // console.log('routeId:::', routeId)
      this.caseStore.selectedCaseId = routeId;
      // window.location.href = "/Cases";
    }

    this.$nextTick(() => {
      this.selectedCase = this.caseStore.selectedCase;
      this.selectedScenario = this.selectedCase?.Id;

      if (this.$route.query.showReportModal == "1") {
        this.showGenerateReportModal = true;
      }
      this.mount();
      this.loading = false;
    });
  },
};
</script>

<style scoped></style>
